var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleanEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 966.39 390.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17,.cls-42,.cls-46,.cls-48,.cls-53,.cls-56,.cls-7{opacity:0.5;}.cls-2{fill:#a7d887;}.cls-3{fill:#5eb85c;}.cls-4{fill:#3a994f;}.cls-5{fill:#5c666e;}.cls-12,.cls-17,.cls-34,.cls-6{fill:#fff;}.cls-20,.cls-6{opacity:0.3;}.cls-8{fill:#131a1d;}.cls-9{fill:#424d54;}.cls-10{fill:#e5e6ec;}.cls-11{fill:#007a94;}.cls-12{opacity:0.4;}.cls-13{fill:#9299a2;}.cls-14{fill:url(#linear-gradient);}.cls-15,.cls-30,.cls-31,.cls-34,.cls-49{opacity:0.2;}.cls-16{fill:#c9ccd4;}.cls-18{fill:#ed403b;}.cls-19{fill:#aeb3bc;}.cls-21{fill:url(#linear-gradient-2);}.cls-22{fill:url(#linear-gradient-3);}.cls-23{fill:#f0f1f7;}.cls-24{fill:#b3bdcc;}.cls-25{fill:#30404b;}.cls-26{fill:#cbd2de;}.cls-27{fill:#485967;}.cls-28{fill:#25343e;}.cls-29{fill:url(#linear-gradient-4);}.cls-30{fill:#113442;}.cls-31{fill:#f1f9fb;}.cls-32{fill:url(#linear-gradient-5);}.cls-33{fill:#404041;opacity:0.1;}.cls-35{fill:#b3c0c8;}.cls-36{fill:#304650;}.cls-37{fill:#152830;}.cls-38{fill:url(#linear-gradient-6);}.cls-39{fill:url(#linear-gradient-7);}.cls-40{fill:#91b63f;}.cls-41{fill:#504943;}.cls-42,.cls-50{fill:#e5e884;}.cls-43{fill:#385a27;}.cls-44{fill:#493b34;}.cls-45{fill:#87ad54;}.cls-46{fill:#a86f41;}.cls-47{fill:#3c8848;}.cls-48,.cls-51{fill:#364a31;}.cls-52{fill:#4d3a30;}.cls-53{fill:#f9fd6f;}.cls-54{fill:#34651c;}.cls-55{fill:#8ac041;}.cls-56{fill:#be6d2b;}.cls-57{fill:#534940;}.cls-58{fill:#5b7b82;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2398.4,
    y1: 863.61,
    x2: -2395.9,
    y2: 854.87,
    gradientTransform: "translate(2947.19 -215.69) rotate(8.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#505b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4e5861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#465058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#384148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#262c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2599.31,
    y1: 728.93,
    x2: -2592.95,
    y2: 706.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2476.85,
    y1: 803.84,
    x2: -2472.68,
    y2: 789.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 601.91,
    y1: 325.76,
    x2: 569.64,
    y2: 364.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#94bee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#80aacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5e89ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2f5c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 495.23,
    y1: 357.77,
    x2: 477.98,
    y2: 337.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002f51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#124063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc5e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 419.57,
    y1: 325.75,
    x2: 387.3,
    y2: 364.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 312.89,
    y1: 357.77,
    x2: 295.65,
    y2: 337.22,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skyline"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 355.59,
    y: 296.66,
    width: 29.03,
    height: 79.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 391.54,
    y: 258.3,
    width: 25.53,
    height: 118.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 397.46,
    y: 308.33,
    width: 49.04,
    height: 68.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 375.52,
    y: 332.57,
    width: 28.78,
    height: 43.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 433.87,
    y: 280.59,
    width: 19.14,
    height: 95.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 465.07,
    y: 223.79,
    width: 42.63,
    height: 152.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 527.29,
    y: 165.97,
    width: 25.49,
    height: 210.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 558.26,
    y: 209.92,
    width: 31.07,
    height: 166.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 446.5,
    y: 317.54,
    width: 45.37,
    height: 58.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 511.29,
    y: 271.98,
    width: 25.02,
    height: 104.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 502.27,
    y: 343.41,
    width: 18.26,
    height: 32.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 346.45,
    y: 343.41,
    width: 18.26,
    height: 32.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 527.29,
    y: 310.48,
    width: 36.4,
    height: 65.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 585.4,
    y: 288.17,
    width: 80.68,
    height: 88.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 815.66,
    y: 362.07,
    width: 80.68,
    height: 14.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 666.08,
    y: 338.98,
    width: 14.76,
    height: 37.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 673.46,
    y: 279.46,
    width: 52.64,
    height: 96.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 717.24,
    y: 210.43,
    width: 29.15,
    height: 165.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 733.96,
    y: 315.63,
    width: 39.36,
    height: 60.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 763.48,
    y: 269.97,
    width: 22.63,
    height: 106.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 781.19,
    y: 239.1,
    width: 54.11,
    height: 137.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 599.17,
    y: 194.72,
    width: 16.73,
    height: 181.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 645.94,
    y: 317.87,
    width: 13.98,
    height: 58.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 140.47,
    y: 296.66,
    width: 29.03,
    height: 79.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.43,
    y: 258.3,
    width: 25.54,
    height: 118.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 182.35,
    y: 308.33,
    width: 49.04,
    height: 68.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.41,
    y: 332.57,
    width: 28.78,
    height: 43.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.77,
    y: 280.59,
    width: 19.14,
    height: 95.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 249.95,
    y: 223.79,
    width: 42.63,
    height: 152.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 312.18,
    y: 183.28,
    width: 25.49,
    height: 193.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 343.15,
    y: 209.92,
    width: 31.07,
    height: 166.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.39,
    y: 317.54,
    width: 45.38,
    height: 58.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 296.18,
    y: 271.98,
    width: 25.02,
    height: 104.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 287.16,
    y: 343.41,
    width: 18.26,
    height: 32.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.34,
    y: 343.41,
    width: 18.26,
    height: 32.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 312.18,
    y: 310.48,
    width: 36.4,
    height: 65.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 370.29,
    y: 288.17,
    width: 80.68,
    height: 88.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.54,
    y: 288.17,
    width: 80.68,
    height: 88.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 450.96,
    y: 338.98,
    width: 14.76,
    height: 37.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 458.35,
    y: 279.46,
    width: 52.64,
    height: 96.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 502.13,
    y: 230.57,
    width: 16.72,
    height: 145.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 518.85,
    y: 315.63,
    width: 39.36,
    height: 60.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 548.37,
    y: 269.97,
    width: 22.63,
    height: 106.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 566.08,
    y: 239.1,
    width: 54.11,
    height: 137.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.06,
    y: 272.67,
    width: 16.73,
    height: 103.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 430.83,
    y: 317.87,
    width: 13.99,
    height: 58.47
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 820.58,
    y: 324.93,
    width: 35.89,
    height: 51.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 780.45,
    y: 300.19,
    width: 31.56,
    height: 76.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 744.06,
    y: 332.46,
    width: 60.64,
    height: 43.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 796.23,
    y: 348.1,
    width: 35.58,
    height: 28.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 736.01,
    y: 314.57,
    width: 23.66,
    height: 61.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 668.39,
    y: 277.93,
    width: 52.71,
    height: 98.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 612.65,
    y: 215.21,
    width: 31.52,
    height: 161.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 567.46,
    y: 283.63,
    width: 38.42,
    height: 92.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 687.96,
    y: 338.41,
    width: 56.1,
    height: 37.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 633.03,
    y: 309.01,
    width: 30.93,
    height: 67.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 652.53,
    y: 355.1,
    width: 22.58,
    height: 21.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 845.18,
    y: 355.1,
    width: 22.58,
    height: 21.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 599.16,
    y: 333.85,
    width: 45.01,
    height: 42.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 472.57,
    y: 319.46,
    width: 99.75,
    height: 56.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 169.5,
    y: 341.43,
    width: 118.13,
    height: 34.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 454.33,
    y: 352.24,
    width: 18.25,
    height: 24.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 398.37,
    y: 313.84,
    width: 65.08,
    height: 62.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 388.64,
    y: 282.3,
    width: 20.68,
    height: 94.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 339.97,
    y: 337.17,
    width: 48.66,
    height: 39.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.16,
    y: 307.72,
    width: 27.99,
    height: 68.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 263.34,
    y: 287.8,
    width: 66.91,
    height: 88.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 534.62,
    y: 277.25,
    width: 20.68,
    height: 99.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 480.19,
    y: 338.62,
    width: 17.29,
    height: 37.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.82,368.54,0,386.5H966.39L885.82,367,797,349.41l-28.05-8.19s-24.76-1.1-33,4.73-89.69-3.8-89.69-3.8-33.31-9.21-39.5-10.38-54.16-13-77.18-9.45-47.24-2.88-67.31,2.71-64.13-3.5-78.41-7.18-83.9,12.94-91,16.12-125.42,22.27-140.28,29S95.82,368.54,95.82,368.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.67,370.18,36.35,386.5H960.49l-19.11-8.07-112.77-7.29-35.49-3.39s-31.33-.46-41.77,1.95-113.49-1.57-113.49-1.57S579.79,372,572,371.52s-52.6-13.09-81.73-11.6-59.77-1.2-85.17,1.12-81.14-1.45-99.22-3-106.15,5.36-115.09,6.68-42.89-6.5-61.69-3.7S72.67,370.18,72.67,370.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wind_Solar",
    "data-name": "Wind Solar"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 423.3,
    y: 361.77,
    width: 6.79,
    height: 24.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 424.19,
    y: 361.77,
    width: 1.04,
    height: 24.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 427.6,
    y: 361.77,
    width: 1.6,
    height: 24.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "453.85 371.91 394.42 376.06 393.89 375.17 453.5 363.68 454.61 369.73 453.85 371.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "468.43 297.6 467.05 297.33 414.67 328.63 393.89 375.17 454.61 369.73 468.43 297.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M414.19,328.26l52.86-30.93-3.42,17.56-55.15,26.18Zm-12.62,28.29,57.54-18.4,4.33-22.3-55.27,25.89Zm-8.07,18.09,59.67-6,5.69-29.27-57.64,17.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M456.19,307.22l-.77.12.67-2.66.94-.85,6.8-3.94.88-.2-.57,2.75-1.05.92Zm-1.27.4.68-2.66-.75.14-6,3.46-.86.78-.76,2.58.67-.08,6.05-3.38Zm-8.09,4.54.76-2.57-.64.1-5.3,3.07-.77.71-.82,2.49.56,0,5.36-3Zm-7.16,4,.82-2.48-.55.06-4.73,2.75-.71.66-.86,2.39h.49l4.76-2.66Zm-6.37,3.58.86-2.39-.48,0-4.24,2.47-.66.62-.89,2.31h.43l4.27-2.38ZM427.58,323l.89-2.32h-.41l-3.83,2.22-.61.58-.91,2.24.37,0,3.84-2.15Zm-5.15,2.89.91-2.24H423l-3.48,2-.56.55-.92,2.17.32,0,3.48-1.95Zm-4.67,2.62.92-2.17-.31,0-3.17,1.84-.53.5-.93,2.1.28.06,3.17-1.77Zm44.51-21.25,1.07-.92.6-2.89-.9.17-6.9,3.85-1,.85-.71,2.78.78-.09Zm-15.39,8.23,6.13-3.28,1-.84.71-2.78-.76.11L447.87,312l-.87.77-.79,2.69Zm-7.1,1.38-.86,2.58h.57l5.41-2.9.87-.76.79-2.68-.64.07-5.36,3Zm-6.44,3.57-.89,2.48.49,0,4.81-2.57.78-.71.85-2.58-.55,0-4.77,2.65Zm-5.76,3.19-.92,2.4.42,0,4.3-2.29.72-.66.9-2.48h-.48L428.25,323Zm-5.19,2.88-.94,2.32.37,0,3.87-2.07.66-.61.92-2.39-.41,0L423,325.89Zm-4.7,2.61-.95,2.24.32.06,3.5-1.87.61-.57.94-2.31-.36,0-3.49,2ZM414,331l-.53.51-1,2.16.28.07,3.17-1.7.57-.53,1-2.24-.32-.05Zm47.46-19.68,1.1-.92.62-3-.91.13-7,3.74-1,.85-.73,2.92.79-.06Zm-8.43,4,.74-2.91-.77.08-6.14,3.27-.88.78-.82,2.8.67,0,6.22-3.16Zm-14.35,5.1-.89,2.68.57,0,5.47-2.79.88-.76.83-2.79-.65,0-5.42,2.89Zm-6.49,3.43-.93,2.59.49,0,4.85-2.46.8-.71.88-2.69h-.55l-4.81,2.56Zm-5.8,3.08-.95,2.49.41.05,4.33-2.19.73-.66.93-2.58-.48,0-4.3,2.3Zm-5.22,2.77-1,2.39.37.08,3.88-2,.67-.61L426,327l-.41,0L421.74,329Zm-4.71,2.5-1,2.31.31.08,3.51-1.78.62-.57,1-2.39-.36-.06L417,331.56Zm-3.75,1.76-.53.51-1,2.23.28.09,3.18-1.62.57-.53,1-2.31-.31-.07Zm47.85-18.34,1.12-.92.66-3.19-.93.1-7.14,3.62-1,.85-.77,3,.8,0Zm-8.57,3.77.77-3.05-.77.05-6.23,3.15-.89.78-.86,2.92.68,0,6.3-3Zm-8.43,4.07.86-2.91h-.65l-5.48,2.77-.81.72-.92,2.8.57,0,5.53-2.66Zm-12.62,3.88-1,2.69.49.07,4.89-2.36.81-.7.93-2.79-.56,0-4.85,2.46Zm-5.84,2.95-1,2.58.41.08,4.36-2.09.74-.66,1-2.68-.48,0-4.33,2.19Zm-5.24,2.64-1,2.48.36.1,3.9-1.88.67-.61,1-2.57-.41-.07-3.89,2Zm-4.73,2.38-1,2.39.31.11L417.9,336l.62-.57,1-2.48-.36-.07-3.5,1.77Zm-4.29,2.17-1,2.29.27.12,3.18-1.53.58-.54,1-2.38-.31-.09-3.18,1.62ZM459,322.72l1.16-.93.71-3.45-.95,0-7.34,3.39-1,.85-.84,3.3.82,0Zm-8.81,3.42.84-3.28-.78,0-6.37,2.94-.91.78L442,329.7l.68.07,6.45-2.79Zm-8.61,3.76.92-3.13-.66,0-5.56,2.57-.83.72-1,3,.58.1,5.62-2.44ZM434,333.18l1-3-.56-.07-4.91,2.27-.76.66-1,2.86.49.11,5-2.14Zm-11.13,2.59-1.05,2.73.41.13,4.4-1.9.75-.65,1-2.86-.48-.09-4.37,2Zm-5.27,2.42-1.07,2.62.36.14,3.92-1.7.69-.61,1-2.73-.41-.1-3.91,1.81Zm-4.75,2.18-1.07,2.51.3.15,3.53-1.53.64-.56,1.06-2.62-.35-.12-3.52,1.63Zm-.55,0-3.19,1.47-.55.51-1.07,2.42.26.15,3.19-1.38.58-.53,1.07-2.51ZM458,327.57l1.18-.92.76-3.64-1,0-7.46,3.22-1.05.86-.87,3.45.82.1Zm-9,3.18.89-3.45-.8-.06L442.64,330l-.93.78-1,3.28.69.12,6.53-2.62Zm-8.73,3.52,1-3.27-.66-.09L435,333.34l-.84.72-1,3.12.57.14,5.69-2.28Zm-7.6,3.07,1-3.11-.56-.11-4.95,2.14-.77.66-1.07,3,.49.15,5-2Zm-11.18,2.12-1.09,2.84.41.16,4.42-1.77L426,340l1.07-3-.47-.12-4.4,1.9Zm-5.29,2.27-1.1,2.72.35.16,3.93-1.57.7-.61,1.09-2.83-.4-.14-3.93,1.7Zm-4.75,2-1.11,2.61.3.17,3.53-1.41.64-.57,1.1-2.71-.34-.14L412,343.23Zm-3.74,1.34-.55.5-1.11,2.5.26.18,3.18-1.28.59-.53,1.11-2.6-.3-.15Zm49.17-12.4,1.2-.93.8-3.84-1-.07-7.6,3-1.06.86-.92,3.63.83.15Zm-9.11,2.88.93-3.62-.81-.11-6.54,2.61-1,.78-1,3.44.69.16,6.62-2.42Zm-8.85,3.27,1-3.43-.67-.13-5.69,2.27-.85.72-1.08,3.26.58.17,5.75-2.09Zm-7.69,2.84,1.08-3.26-.56-.14-5,2-.78.66-1.11,3.1.48.19,5-1.84ZM420,343.3l-1.13,2.95.4.2,4.44-1.63.77-.65,1.12-3.09-.48-.15-4.41,1.76Zm-1.46,3.07,1.14-2.95-.4-.16-3.94,1.57-.65.57-1.14,2.82.34.19,3.95-1.44Zm-8.61.91L408.81,350l.29.2,3.53-1.29.65-.56,1.14-2.81-.34-.18-3.53,1.41Zm-3.73,1.19-.56.5-1.14,2.59.25.2,3.18-1.17.6-.52,1.14-2.69-.29-.18Zm49.51-10.35,1.24-.93.83-4.06-1-.13-7.73,2.82-1.09.84-1,3.83.85.2Zm-9.26,2.56,1-3.82-.81-.16L440,339.12l-1,.77L438,343.5l.69.21,6.72-2.2Zm-9,3,1.07-3.6-.67-.18-5.75,2.1-.87.7-1.12,3.42.57.22,5.8-1.9Zm-7.76,2.57,1.12-3.4-.56-.19-5,1.84-.78.65-1.16,3.23.48.23,5.07-1.66ZM423,348.48l1.16-3.22-.47-.2-4.43,1.62-.72.61-1.18,3.07.4.23,4.46-1.47Zm-6,2,1.18-3.07-.4-.2-3.95,1.44-.65.56L412,352.13l.34.23,3.95-1.3Zm-5.3,1.75,1.19-2.92-.34-.2L409,350.38l-.61.54-1.19,2.79.29.23,3.54-1.16ZM407,353.8l1.19-2.79-.29-.21L404.68,352l-.56.5-1.18,2.67.24.23,3.18-1Zm46.81-6.44,1.29-.91L456,342l-1-.24-8,2.41-1.12.84-1.05,4.17.85.3Zm-9.52,2,1.07-4.16-.83-.24L437.72,347l-1,.76-1.15,3.9.7.31,6.86-1.8Zm-9.17,2.44,1.16-3.89-.68-.26-5.84,1.77-.89.7-1.21,3.67.58.31,5.89-1.55Zm-7.88,2.11,1.21-3.66-.56-.26-5.08,1.54-.81.64-1.24,3.47.48.3,5.12-1.35Zm-6.85,1.82,1.25-3.45-.47-.26-4.47,1.35-.73.6-1.26,3.28.4.3,4.49-1.19Zm-6,1.61,1.26-3.27-.39-.26-4,1.2-.67.55-1.26,3.11.33.29,4-1ZM409,358.72l1.27-3.1-.33-.26-3.53,1.07-.61.53-1.26,3,.27.27,3.53-.92ZM404.32,360l1.26-3-.28-.25-3.17,1-.57.49-1.24,2.82.23.28,3.16-.83Zm48.12-6.33,1.31-.9,1-4.73-1-.31-8.1,2.1-1.15.84-1.11,4.4.86.39Zm-9.68,1.53,1.12-4.38-.83-.32-6.87,1.78-1,.76L434,357.13l.7.37,6.95-1.5Zm-9.3,2.06,1.22-4.1-.68-.31-5.9,1.53-.9.7-1.26,3.84.56.37,5.95-1.29ZM425.51,359l1.27-3.84-.56-.31-5.12,1.33-.81.64-1.3,3.62.47.36,5.15-1.12Zm-6.89,1.52,1.3-3.6-.46-.31L415,357.77l-.74.6-1.31,3.42.39.33,4.5-1Zm-6,1.33,1.31-3.4-.38-.3-4,1-.67.56L407.58,363l.32.33,4-.86ZM407.29,363l1.31-3.22-.32-.3-3.53.92-.61.52L402.83,364l.27.31,3.52-.76Zm-4.72,1,1.31-3.06-.27-.28-3.16.82-.57.49L398.59,365l.22.31,3.15-.69ZM451,360.34l1.35-.89,1-5-1.05-.4-8.25,1.77-1.17.82-1.18,4.67.88.46Zm-11,1.84,1.17-.8,1.19-4.65-.84-.39-7,1.49-1,.75-1.27,4.33.7.45Zm-8.25.82,1.29-4.32-.68-.38-6,1.28-.91.68-1.33,4,.57.43,6-1Zm-8,1.38,1.33-4-.55-.37-5.15,1.1-.83.63-1.36,3.79.47.41,5.18-.86Zm-6.92,1.19,1.36-3.78-.46-.36-4.5,1-.75.59-1.37,3.57.39.39,4.5-.75Zm-6,1,1.37-3.55-.38-.35-4,.85-.67.55-1.37,3.37.32.37,4-.66Zm-5.31.91,1.37-3.35-.32-.33-3.51.75-.63.51L401,368.28l.26.36,3.51-.59Zm-4.7.81,1.36-3.18-.26-.32-3.15.67-.57.49-1.35,3,.22.34,3.13-.52Zm40.58-5.39-1.25,4.94.88.56,8.54-1,1.38-.87,1.11-5.36-1.06-.5-8.4,1.37Zm-9.53,1.51L430.46,369l.7.52,7.14-.8,1.19-.78,1.26-4.93-.84-.47-7.05,1.15Zm-8.12,1.29-1.4,4.24.57.5,6.05-.68,1-.72,1.34-4.55-.67-.46-6,1Zm-7,1.1-1.42,4,.45.47,5.2-.58.93-.66,1.4-4.23-.55-.44-5.18.85Zm-6.08,1-1.44,3.72.38.45,4.51-.51.83-.61,1.43-4-.45-.41-4.51.74Zm-5.35.85-1.42,3.5.31.42,3.95-.44.75-.57,1.43-3.71-.37-.39-4,.64Zm-4.73.74-1.41,3.32.25.4,3.5-.4.68-.52,1.43-3.5-.31-.38-3.51.58Zm-4.21.67-1.39,3.15.2.37,3.11-.34.63-.5,1.41-3.3-.26-.37-3.12.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "438.49 314.04 414.19 328.26 393.5 374.64 438.49 314.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 497.04,
    y: 344.97,
    width: 11.41,
    height: 41.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 498.52,
    y: 344.97,
    width: 1.75,
    height: 41.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 504.26,
    y: 344.97,
    width: 2.68,
    height: 41.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "548.34 361.99 448.54 368.96 447.64 367.47 547.75 348.18 549.62 358.33 548.34 361.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "572.82 237.21 570.5 236.75 482.54 289.31 447.64 367.47 549.62 358.33 572.82 237.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M481.74,288.7l88.76-51.95-5.74,29.49-92.62,44Zm-21.19,47.5,96.61-30.89,7.28-37.45-92.81,43.48ZM447,366.58l100.2-10,9.56-49.14L460,337.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M552.26,253.36l-1.3.21,1.13-4.47,1.59-1.43,11.41-6.62,1.48-.33-1,4.63-1.76,1.54Zm-2.13.68,1.14-4.47-1.26.23-10,5.82-1.43,1.3-1.27,4.33,1.11-.13,10.16-5.68Zm-13.59,7.62,1.28-4.32-1.07.17-8.89,5.15-1.31,1.2L525.18,268l1-.07,9-5Zm-12,6.74,1.37-4.16-.93.1-7.93,4.6-1.19,1.12-1.45,4,.82,0,8-4.46Zm-10.71,6,1.45-4-.81,0-7.12,4.14-1.1,1-1.5,3.89.72,0,7.17-4Zm-9.6,5.38,1.5-3.88H505l-6.43,3.73-1,1L496,284.39l.62,0,6.46-3.61Zm-8.65,4.86,1.53-3.76-.61,0-5.83,3.38-1,.92-1.55,3.64.54.07,5.85-3.27Zm-7.84,4.4,1.55-3.64-.53,0-5.32,3.09-.89.85L481,292.83l.47.1,5.33-3Zm74.75-35.68,1.8-1.54,1-4.85-1.51.27-11.59,6.47-1.62,1.42-1.18,4.68,1.32-.15Zm-25.86,13.81,10.3-5.5,1.61-1.4,1.2-4.67-1.27.18-10.17,5.67-1.46,1.3-1.32,4.51ZM524.7,269.5l-1.43,4.34,1,0,9.09-4.85,1.45-1.29,1.33-4.5-1.08.12-9,5Zm-10.8,6-1.5,4.18.82,0,8.07-4.31,1.32-1.19,1.43-4.33-.93.05-8,4.47Zm-9.68,5.37-1.54,4,.7.06,7.22-3.86,1.21-1.1,1.51-4.17h-.81l-7.17,4Zm-8.71,4.84-1.58,3.88.61.09,6.5-3.47,1.11-1,1.55-4-.7,0-6.46,3.61Zm-7.89,4.38-1.6,3.75.53.11,5.88-3.14,1-1L495,286l-.61-.06-5.85,3.27Zm-6.29,3.13-.89.85-1.61,3.63.47.13,5.33-2.85,1-.91,1.6-3.74-.53-.09Zm79.7-33,1.85-1.56,1-5.08-1.53.22L550.61,260,549,261.47l-1.24,4.89,1.34-.1Zm-14.16,6.63,1.25-4.89-1.29.14-10.31,5.49L535,268.85l-1.38,4.7,1.12,0,10.45-5.31Zm-24.1,8.56-1.49,4.51,1,0,9.19-4.67,1.48-1.29,1.38-4.69-1.09.07-9.09,4.84Zm-10.89,5.77-1.56,4.34.82.07,8.14-4.14,1.34-1.19,1.49-4.5h-.93L513.1,280Zm-9.74,5.17-1.6,4.18.7.09,7.26-3.69,1.23-1.1,1.56-4.33-.8,0-7.22,3.85ZM493.38,291l-1.63,4,.61.12,6.52-3.32,1.13-1,1.6-4.17-.69-.07-6.5,3.46Zm-7.92,4.19L483.81,299l.53.14,5.89-3,1-1,1.64-4-.61-.09-5.87,3.13Zm-6.29,3-.9.86-1.66,3.74.47.16,5.34-2.72,1-.9,1.65-3.87-.52-.12Zm80.36-30.79,1.87-1.56,1.11-5.34-1.56.16-12,6.08-1.67,1.43L546,273.2l1.34,0Zm-14.41,6.32,1.31-5.12-1.3.08-10.46,5.3-1.5,1.31-1.44,4.91,1.13,0L543.45,275ZM531,280.47l1.45-4.89h-1.1l-9.19,4.66-1.37,1.2-1.55,4.7,1,.08,9.28-4.46ZM509.77,287l-1.61,4.51.82.12,8.21-3.95,1.36-1.19,1.55-4.69-.94,0L511,285.88Zm-9.8,4.94-1.66,4.34.7.14,7.31-3.52,1.24-1.1,1.62-4.5-.8-.08-7.26,3.69Zm-8.79,4.44-1.69,4.16.6.17,6.55-3.15,1.14-1,1.67-4.32-.7-.11-6.52,3.32Zm-7.94,4-1.7,4,.51.18,5.91-2.84,1.05-1,1.69-4.16-.59-.13-5.89,3ZM476,304l-1.71,3.87.45.19,5.35-2.57,1-.9,1.7-4-.51-.15L477,303.15ZM557,279.39l1.93-1.55,1.2-5.8-1.59,0-12.32,5.7-1.72,1.43-1.4,5.53,1.37.07Zm-14.79,5.74,1.41-5.5-1.33,0-10.68,4.94L530,285.85l-1.55,5.26,1.14.13,10.83-4.69Zm-14.47,6.32,1.56-5.25-1.11-.08-9.35,4.32-1.4,1.2-1.65,5,1,.16,9.45-4.09ZM515.08,297l1.65-5-.94-.13-8.24,3.82-1.27,1.11-1.73,4.8.83.19,8.31-3.6Zm-18.7,4.33-1.76,4.6.69.22,7.38-3.2,1.26-1.09,1.73-4.79-.8-.16-7.34,3.39Zm-8.85,4.07-1.79,4.4.59.24,6.59-2.86,1.16-1,1.76-4.58-.68-.18-6.57,3Zm-8,3.66-1.79,4.23.51.24,5.92-2.57,1.07-.94,1.78-4.4-.59-.2-5.9,2.74Zm-.93,0-5.35,2.47-.92.85-1.8,4.06.44.25,5.35-2.31,1-.9,1.79-4.21Zm76.62-21.47,2-1.56,1.27-6.11-1.62,0-12.54,5.41-1.75,1.43-1.47,5.81,1.39.15Zm-15,5.32,1.48-5.79-1.34-.09-10.82,4.66L527.94,293l-1.62,5.52,1.16.2,11-4.4Zm-14.67,5.92,1.64-5.49-1.12-.15-9.46,4.08-1.41,1.2-1.72,5.24,1,.24,9.55-3.83ZM512.77,304l1.73-5.23-.94-.18-8.32,3.59L504,303.24l-1.79,5,.81.25,8.38-3.36ZM494,307.51l-1.83,4.77.69.27,7.42-3,1.27-1.1,1.8-5-.8-.21-7.38,3.18Zm-8.89,3.8-1.85,4.57.59.28,6.61-2.65,1.16-1,1.84-4.75-.68-.23-6.59,2.85Zm-8,3.42-1.86,4.37.5.29L481.7,317l1.08-.95,1.85-4.55-.58-.24-5.92,2.55ZM470.85,317l-.93.84-1.86,4.2.44.29,5.34-2.14,1-.89,1.87-4.36-.5-.25Zm82.57-20.83,2-1.55,1.33-6.45-1.64-.12-12.76,5.09-1.79,1.43L539,300.66l1.41.24ZM538.12,301l1.56-6.09-1.35-.18-11,4.38-1.6,1.31-1.7,5.77,1.16.28,11.13-4.07Zm-14.87,5.49,1.71-5.77-1.12-.21-9.55,3.81-1.44,1.2-1.8,5.47,1,.3,9.64-3.52Zm-12.9,4.76,1.81-5.47-.94-.24-8.38,3.34L501.53,310l-1.86,5.21.81.31,8.44-3.09ZM491.53,314l-1.91,5,.69.32,7.45-2.72,1.3-1.09,1.87-5.19-.8-.26-7.41,2.95Zm-2.45,5.16,1.91-4.95-.68-.28-6.61,2.63-1.09,1-1.92,4.74.58.33,6.63-2.42Zm-14.46,1.52-1.93,4.53.5.33,5.93-2.16,1.09-.94,1.92-4.73-.58-.29-5.92,2.37Zm-6.27,2-.93.84-1.93,4.34.43.34,5.34-2,1-.88,1.93-4.52-.5-.29Zm83.14-17.39,2.08-1.56,1.4-6.81-1.66-.22-13,4.72-1.82,1.42-1.63,6.44,1.42.34Zm-15.56,4.3,1.65-6.41-1.37-.26-11.13,4.05-1.63,1.29-1.78,6.07,1.16.36,11.28-3.7Zm-15.07,5,1.79-6-1.12-.29-9.65,3.51-1.46,1.19-1.89,5.73,1,.37,9.74-3.19Zm-13,4.33,1.89-5.71-.94-.32-8.45,3.08L499,317l-1.95,5.44.82.38,8.5-2.79Zm-11.38,3.78,1.95-5.41-.79-.34-7.45,2.72-1.2,1-2,5.15.68.39,7.49-2.45Zm-10,3.33,2-5.15-.67-.34-6.63,2.41-1.1.95-2,4.92.58.38,6.63-2.18Zm-8.89,2.95,2-4.9-.56-.34L473,325.85l-1,.89-2,4.69.48.39,5.93-1.95Zm-8,2.64,2-4.68-.48-.35-5.34,1.95-.95.83-2,4.48.41.4,5.33-1.76Zm78.61-10.81,2.16-1.54,1.54-7.47-1.7-.39-13.36,4L535,316.82l-1.77,7,1.44.51Zm-16,3.31,1.79-7-1.39-.42-11.38,3.45-1.67,1.28L517.64,328l1.18.51,11.52-3Zm-15.4,4.1,1.94-6.53-1.13-.43-9.81,3-1.5,1.17-2,6.16,1,.52,9.9-2.6Zm-13.23,3.53,2-6.14-.94-.44-8.54,2.59-1.35,1.08-2.08,5.82.79.5,8.6-2.25Zm-11.5,3.07,2.09-5.79-.79-.44-7.5,2.27-1.23,1-2.11,5.51.67.5,7.53-2ZM482,337.47l2.11-5.49-.66-.43-6.65,2-1.11.94-2.12,5.22.55.49,6.66-1.75Zm-8.92,2.38,2.13-5.2-.56-.44-5.93,1.8-1,.87-2.12,5,.46.47,5.93-1.54ZM465.16,342l2.11-5-.46-.42-5.32,1.61-1,.82-2.09,4.74.39.47,5.3-1.4ZM546,331.34l2.21-1.52,1.64-7.94-1.73-.52-13.6,3.53-1.93,1.4-1.87,7.4,1.46.64Zm-16.25,2.57,1.88-7.37-1.4-.53-11.53,3-1.7,1.27-2,6.91,1.18.62,11.67-2.53Zm-15.61,3.45,2-6.87L515,330l-9.9,2.58-1.51,1.17-2.13,6.46,1,.61,10-2.16Zm-13.36,3,2.13-6.44-.93-.53-8.6,2.23L492,336.66l-2.17,6.08.79.59,8.64-1.88Zm-11.57,2.56,2.19-6.06-.78-.52-7.53,2-1.24,1-2.2,5.74.65.57,7.56-1.63Zm-10.1,2.23,2.2-5.71-.65-.51L474,340.62l-1.14.93-2.2,5.43.54.55,6.66-1.44Zm-8.92,2,2.2-5.41-.54-.5-5.92,1.54-1,.87-2.19,5.15.46.54L469,348Zm-7.92,1.75,2.19-5.15-.45-.47-5.31,1.38-1,.82-2.17,4.9.38.52,5.29-1.15Zm81.36-6.27,2.26-1.49,1.75-8.44-1.77-.68-13.84,3-2,1.39-2,7.83,1.46.78Zm-18.51,3.09,2-1.35,2-7.8-1.41-.66L516,338.35l-1.73,1.26-2.15,7.27,1.18.75ZM511.23,347l2.15-7.24-1.14-.65-10,2.14-1.54,1.15-2.24,6.79,1,.71,10.08-1.67Zm-13.47,2.32,2.23-6.77-.93-.62-8.65,1.85L489,344.87l-2.28,6.36.78.69,8.69-1.45Zm-11.63,2,2.28-6.35-.77-.6L480.09,346l-1.25,1-2.3,6,.64.66,7.57-1.27ZM476,353.09l2.3-6-.63-.58L471,348l-1.14.92-2.29,5.66.52.62,6.65-1.11Zm-8.91,1.53,2.3-5.63-.53-.57-5.91,1.27-1.05.86-2.28,5.35.44.6,5.9-1ZM459.19,356l2.27-5.34-.43-.54-5.29,1.13-1,.82-2.25,5.08.36.58,5.25-.88Zm68.14-9.06-2.1,8.31,1.48.93,14.34-1.6,2.32-1.47,1.86-9-1.79-.83-14.1,2.31Zm-16,2.54-2.26,7.68,1.18.88,12-1.35,2-1.32,2.12-8.27-1.42-.8-11.84,1.94Zm-13.63,2.16-2.35,7.14,1,.82,10.17-1.14,1.75-1.2,2.27-7.65-1.14-.76-10.09,1.65ZM486,353.47l-2.39,6.67.77.78,8.73-1,1.56-1.11,2.35-7.1L496,351l-8.69,1.43Zm-10.22,1.62-2.4,6.25.63.75,7.58-.86,1.4-1,2.38-6.64-.75-.69L477,354.12Zm-9,1.42-2.39,5.9.52.7,6.63-.75,1.27-.95,2.39-6.23-.61-.66-6.66,1.09Zm-7.94,1.26-2.37,5.57.42.67,5.87-.66,1.15-.89,2.39-5.87-.51-.63-5.9,1Zm-7.08,1.13-2.34,5.28.35.63,5.22-.59,1.06-.83,2.36-5.55-.43-.6-5.25.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "522.55 264.82 481.74 288.7 446.99 366.58 522.55 264.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 611.16,
    y: 318.71,
    width: 18.63,
    height: 67.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 613.58,
    y: 318.71,
    width: 2.85,
    height: 67.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 622.95,
    y: 318.71,
    width: 4.38,
    height: 67.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "694.9 346.5 532 357.87 530.53 355.44 693.93 323.94 696.99 340.52 694.9 346.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "734.85 142.79 731.06 142.05 587.49 227.85 530.53 355.44 696.99 340.52 734.85 142.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M586.18,226.86l144.88-84.81L721.7,190.2,570.51,262Zm-34.59,77.53L709.29,254l11.89-61.13-151.49,71ZM529.46,354,693,337.59l15.61-80.22-158,49.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M701.3,169.17l-2.12.33,1.85-7.31,2.58-2.31,18.62-10.81,2.42-.54-1.56,7.55-2.88,2.52Zm-3.48,1.09,1.86-7.29-2,.38-16.37,9.51L678.92,175,676.84,182l1.81-.21,16.59-9.27Zm-22.18,12.45,2.09-7-1.76.25-14.51,8.43-2.13,2-2.24,6.81,1.55-.12,14.66-8.19Zm-19.61,11,2.24-6.8-1.51.16-13,7.51-1.95,1.82L639.5,203l1.34,0,13.06-7.29Zm-17.48,9.81,2.36-6.57-1.3.08L628,203.79l-1.8,1.69-2.44,6.35,1.17,0,11.7-6.54Zm-15.66,8.78,2.44-6.34-1.14,0-10.5,6.09L612,213.66l-2.49,6.15,1,.08,10.55-5.9Zm-14.13,7.93,2.5-6.13-1,0-9.52,5.53-1.55,1.49L596.67,227l.87.12,9.56-5.34ZM596,227.42l2.53-5.92-.87-.09-8.68,5-1.45,1.4-2.55,5.75.77.15,8.7-4.86Zm122-58.24,2.93-2.53,1.63-7.91-2.45.45-18.93,10.56-2.63,2.32-1.93,7.64,2.15-.26Zm-42.21,22.55,16.82-9,2.62-2.3,1.95-7.62-2.07.3-16.6,9.25-2.37,2.13L674,191.87ZM656.3,195.5,654,202.59l1.56,0,14.84-7.93,2.37-2.1,2.17-7.34-1.77.19-14.67,8.17Zm-17.63,9.79-2.44,6.83,1.34,0,13.18-7,2.15-2,2.34-7.06-1.52.09-13.06,7.28Zm-15.78,8.77-2.53,6.58,1.16.08,11.78-6.29,2-1.8,2.45-6.81-1.32,0-11.7,6.52ZM608.66,222l-2.58,6.35,1,.13,10.6-5.66,1.81-1.67,2.53-6.57-1.13-.05-10.56,5.89Zm-12.88,7.15-2.61,6.13.87.17,9.59-5.12,1.68-1.56,2.58-6.34-1-.09-9.56,5.32Zm-10.26,5.11-1.46,1.4-2.62,5.92.76.2,8.71-4.65,1.56-1.47,2.61-6.12-.87-.13Zm130.1-53.93,3-2.54,1.72-8.3-2.49.36L698.6,180.06l-2.69,2.33-2,8,2.19-.16ZM692.49,191.1l2-8-2.1.21-16.82,9-2.42,2.14-2.26,7.67,1.84-.05,17.05-8.67Zm-39.33,14-2.43,7.37,1.57,0,15-7.62,2.41-2.11,2.27-7.66-1.78.11-14.84,7.9Zm-17.78,9.43-2.54,7.09,1.34.1,13.28-6.75,2.19-1.95,2.43-7.35-1.52,0-13.18,7Zm-15.9,8.43-2.62,6.82,1.16.16,11.85-6,2-1.8,2.55-7.07-1.31,0-11.79,6.28Zm-14.3,7.59-2.66,6.56,1,.2,10.64-5.41,1.84-1.68,2.62-6.8-1.13-.11-10.61,5.66Zm-12.92,6.85-2.69,6.33.86.23,9.61-4.88,1.7-1.57,2.66-6.55-1-.15-9.59,5.11ZM582,242.2l-1.47,1.4-2.7,6.11.75.25,8.72-4.43,1.57-1.47,2.7-6.31-.85-.2Zm131.17-50.26,3.06-2.55,1.8-8.73-2.54.27-19.56,9.92-2.73,2.34-2.12,8.37,2.2-.06Zm-23.52,10.31,2.13-8.35-2.12.13-17.06,8.64-2.45,2.14-2.36,8,1.85,0,17.28-8.31Zm-23.1,11.17,2.36-8-1.79,0-15,7.61-2.23,2-2.52,7.67,1.57.13,15.16-7.29Zm-34.6,10.65-2.64,7.36,1.35.18,13.4-6.45,2.21-1.93,2.54-7.66-1.53-.06L634,222.25Zm-16,8.06-2.72,7.07,1.15.23,11.93-5.73,2-1.8,2.64-7.34-1.31-.13-11.86,6Zm-14.36,7.25-2.76,6.79,1,.27,10.69-5.14,1.86-1.67,2.71-7.06L614,232.4l-10.64,5.4Zm-13,6.53-2.77,6.54.85.29,9.64-4.63,1.71-1.56,2.76-6.78-1-.22-9.62,4.88Zm-11.75,5.93-2.79,6.3.74.32,8.73-4.2,1.59-1.47,2.78-6.52-.84-.25-8.72,4.42ZM709,211.66l3.16-2.54,2-9.46-2.6.08L691.4,209l-2.82,2.34-2.29,9,2.25.12ZM684.84,221l2.3-9L685,212l-17.44,8.06L665,222.2l-2.54,8.6,1.87.2L682,223.34Zm-23.61,10.31,2.53-8.58-1.81-.12-15.26,7-2.27,2-2.7,8.21,1.57.26,15.42-6.68Zm-20.62,9,2.7-8.18-1.54-.2-13.46,6.22L626.23,240l-2.81,7.84,1.34.31,13.58-5.88Zm-30.53,7.08-2.88,7.5,1.14.35,12-5.22,2.06-1.78,2.82-7.82-1.31-.25-12,5.53Zm-14.46,6.64-2.92,7.19,1,.37L604.43,257l1.9-1.66,2.88-7.48-1.12-.29-10.72,5Zm-13,6-2.92,6.9.82.4,9.67-4.19,1.74-1.56,2.92-7.16-1-.32-9.65,4.45Zm-1.53,0-8.73,4-1.5,1.38-2.94,6.63.73.42,8.73-3.79,1.61-1.45,2.93-6.89Zm125.08-35,3.24-2.54,2.06-10-2.64,0-20.46,8.83-2.87,2.34-2.39,9.48,2.26.25Zm-24.55,8.68,2.42-9.44-2.19-.16-17.67,7.63-2.57,2.14-2.65,9,1.89.32L678.75,236Zm-23.94,9.68,2.66-9-1.82-.24-15.43,6.66-2.31,2L638,251.3l1.58.37,15.59-6.24Zm-20.84,8.42,2.83-8.53-1.54-.3-13.58,5.86-2.09,1.81-2.93,8.16,1.33.41,13.68-5.48Zm-30.64,5.8-3,7.79,1.13.44,12.11-4.85,2.09-1.78,2.93-8.14-1.31-.34-12,5.2Zm-14.5,6.22-3,7.45,1,.45,10.79-4.32,1.92-1.65,3-7.77-1.11-.37-10.76,4.64Zm-13,5.58-3,7.13.82.48,9.68-3.88,1.76-1.55,3-7.43-.95-.39-9.66,4.17ZM568.41,273l-1.52,1.37-3,6.86.71.47,8.72-3.49,1.62-1.45,3-7.12-.81-.41Zm134.77-34,3.32-2.54L708.67,226l-2.68-.19-20.82,8.31-2.92,2.33-2.53,10,2.29.39Zm-25,7.91,2.54-10-2.21-.28-17.92,7.15L658,246l-2.78,9.43,1.9.45,18.16-6.64Zm-24.27,9,2.79-9.4-1.84-.36-15.59,6.22-2.34,2-3,8.94,1.58.48L651.35,258Zm-21.06,7.77,3-8.91-1.53-.4-13.69,5.45-2.12,1.81-3,8.5,1.32.51,13.78-5Zm-30.73,4.41-3.11,8.09,1.12.53,12.16-4.44,2.12-1.77,3-8.48-1.29-.43-12.11,4.82Zm-4,8.42,3.11-8.07-1.1-.46-10.8,4.3-1.78,1.56-3.13,7.73.95.54,10.81-3.95ZM574.56,279l-3.14,7.39.8.55,9.68-3.55,1.78-1.53,3.14-7.71-.94-.47-9.67,3.86Zm-10.23,3.27-1.53,1.38-3.14,7.08.69.55,8.72-3.19,1.64-1.44,3.14-7.37-.8-.49ZM700,253.86l3.39-2.53,2.3-11.13-2.72-.36-21.2,7.71-3,2.33-2.66,10.5,2.32.55Zm-25.39,7,2.68-10.47L675.1,250l-18.18,6.61-2.65,2.12-2.91,9.89,1.9.59,18.41-6Zm-24.6,8.17,2.92-9.87-1.84-.48-15.76,5.73L633,266.39l-3.08,9.35,1.57.62,15.91-5.23Zm-21.28,7.06,3.09-9.32-1.54-.52-13.78,5-2.16,1.79L611.19,282l1.33.62L626.4,278Zm-18.57,6.17,3.18-8.84-1.28-.54-12.18,4.42L598,279l-3.23,8.42,1.1.64,12.22-4Zm-16.36,5.43,3.24-8.4-1.09-.56-10.82,3.95-1.79,1.54-3.27,8,.94.64,10.84-3.56Zm-14.52,4.82,3.26-8-.92-.56L572,287.5,570.32,289l-3.26,7.66.79.63,9.68-3.18Zm-13,4.3,3.25-7.63-.78-.57-8.72,3.17-1.54,1.37-3.24,7.32.67.63,8.7-2.86ZM694.67,279.2l3.52-2.5,2.52-12.2-2.79-.64-21.79,6.59-3.09,2.3-2.89,11.44,2.35.83Zm-26.09,5.4,2.92-11.38-2.26-.69-18.57,5.62-2.73,2.09L644.78,291l1.93.84,18.8-4.93Zm-25.13,6.7,3.16-10.66-1.85-.7-16,4.84-2.44,1.92L623,296.76l1.57.84,16.15-4.24Zm-21.61,5.77,3.32-10-1.53-.71-13.94,4.21-2.2,1.78-3.4,9.49,1.29.83,14-3.68Zm-18.76,5,3.4-9.47-1.28-.71L593,295.6l-2,1.65-3.45,9,1.08.81,12.29-3.23Zm-16.46,4.39,3.45-9L589,296.8l-10.85,3.28-1.83,1.54-3.46,8.52.91.79,10.86-2.85Zm-14.55,3.88,3.46-8.5-.9-.7L565,304.07l-1.68,1.44-3.44,8.11.75.77,9.67-2.53Zm-13,3.45,3.44-8.08-.75-.7-8.69,2.63L551.56,309l-3.42,7.73.64.76,8.66-2.27ZM691,296.45l3.6-2.47,2.68-13-2.83-.86-22.19,5.77-3.16,2.29-3,12.07,2.38,1Zm-26.54,4.2,3.07-12-2.27-.87-18.83,4.9-2.77,2.07L640.36,306l1.92,1,19.06-4.13ZM639,306.28l3.33-11.22-1.86-.87-16.17,4.21-2.47,1.9-3.47,10.56,1.56,1,16.31-3.53Zm-21.81,4.83,3.48-10.51-1.53-.86-14,3.65-2.23,1.75-3.55,9.93,1.28,1L614.74,313Zm-18.88,4.18,3.56-9.89-1.26-.84-12.3,3.19-2,1.63-3.6,9.36,1.07.94L596.1,317Zm-16.5,3.65,3.59-9.33-1-.83-10.86,2.83-1.85,1.51-3.6,8.86.89.91,10.86-2.35Zm-14.56,3.22,3.6-8.83-.88-.81L560.31,315l-1.7,1.42L555,324.87l.74.87,9.65-2.09ZM554.34,325l3.57-8.39-.74-.79-8.66,2.26L547,319.43l-3.54,8,.61.85,8.63-1.87Zm132.8-10.23,3.69-2.43,2.85-13.79-2.88-1.1-22.6,4.83L665,304.56l-3.24,12.8,2.4,1.26Zm-30.21,5,3.21-2.2,3.25-12.73-2.29-1.08L642,307.9,639.19,310l-3.49,11.87,1.92,1.22Zm-22.6,2.24,3.51-11.83-1.86-1-16.32,3.49-2.51,1.87-3.65,11.09,1.56,1.16,16.45-2.74Zm-22,3.78,3.65-11-1.52-1-14.12,3-2.26,1.74-3.72,10.38,1.28,1.12,14.18-2.37Zm-19,3.26,3.72-10.35-1.25-1-12.33,2.64-2,1.61-3.76,9.77,1,1.07,12.36-2.06ZM576.8,332l3.75-9.75-1-.94-10.87,2.32-1.86,1.5L563,334.32l.87,1,10.86-1.81Zm-14.54,2.5,3.74-9.2-.86-.92-9.65,2.07-1.71,1.4-3.71,8.74.71,1,9.62-1.61Zm-12.89,2.21,3.71-8.71-.71-.89-8.63,1.85-1.57,1.32-3.67,8.3.59.94,8.57-1.43Zm111.24-14.79-3.44,13.55,2.42,1.54L683,334.33l3.79-2.39,3-14.69-2.92-1.37-23,3.77ZM634.46,326l-3.68,12.53L632.7,340l19.56-2.2,3.28-2.16,3.45-13.5-2.32-1.3L637.34,324Zm-22.24,3.53-3.83,11.65,1.54,1.35,16.6-1.86,2.86-2,3.7-12.48L631.23,325l-16.46,2.69Zm-19.17,3-3.9,10.88,1.26,1.27,14.25-1.6,2.55-1.8L611,329.73l-1.51-1.18-14.19,2.33Zm-16.67,2.64-3.93,10.21,1,1.21,12.38-1.39,2.27-1.67L592,332.75l-1.24-1.13-12.36,2Zm-14.65,2.32-3.9,9.62.84,1.15,10.84-1.22,2.06-1.56,3.92-10.17-1-1.08-10.87,1.78Zm-13,2.06-3.87,9.08.69,1.1,9.58-1.08,1.87-1.45,3.91-9.58-.84-1-9.62,1.58Zm-11.56,1.83-3.81,8.61.56,1.05,8.53-1,1.71-1.36,3.86-9-.68-1-8.59,1.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "652.8 187.87 586.18 226.86 529.46 353.98 652.8 187.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M448.84,280.63l3.84.86,8.69,2.67,2.16-.15a7.6,7.6,0,0,0,1.88-4.13,3.26,3.26,0,0,0-2.05-3.17l-13.42-3.25s-1.78,1.36-1.78,2.73A30.81,30.81,0,0,0,448.84,280.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M465.41,279.88a3.26,3.26,0,0,0-2.05-3.17l-13.42-3.25s-1.78,1.36-1.78,2.73C452.4,277.49,459.9,278,465.41,279.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M450.29,277.35c-.25,1.72-1.18,3-2.07,2.87s-1.39-1.64-1.14-3.35,1.19-3,2.08-2.86S450.55,275.64,450.29,277.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M448.84,280.63l3.84.86,8.69,2.67,2.16-.15s-1.22-3.58-15.37-7.82A30.81,30.81,0,0,0,448.84,280.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "448.29 275.77 439.21 260.11 412.01 241.07 410.85 242.29 447.12 276.98 448.29 275.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 428.73,
    y: 233.93,
    width: 1.68,
    height: 50.19,
    transform: "translate(-54.54 390.44) rotate(-46.28)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "417.81 245.13 415.9 247.12 414.19 245.48 415.84 243.75 417.81 245.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "413.97 242.44 412.56 243.93 410.85 242.29 412.01 241.07 413.97 242.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "448.06 276.71 466.16 276.69 496.24 262.65 495.76 261.03 447.58 275.1 448.06 276.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 446.81,
    y: 268.03,
    width: 50.19,
    height: 1.68,
    transform: "translate(-56.44 143.02) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "489.83 265.64 489.06 262.99 491.33 262.33 492 264.63 489.83 265.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "494.07 263.66 493.49 261.7 495.76 261.03 496.24 262.65 494.07 263.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "447.36 276.04 438.32 291.73 435.44 324.8 437.07 325.2 448.98 276.44 447.36 276.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "447.36 276.04 435.44 324.8 437.07 325.2 448.98 276.44 447.36 276.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "436.05 317.75 438.73 318.41 438.17 320.71 435.85 320.14 436.05 317.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "435.64 322.42 437.63 322.9 437.07 325.2 435.44 324.8 435.64 322.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M449,277c.19-1.77-.23-3.66-1.52-3.31s-3.59,2-3.5,2.64,1.78,2.2,3.1,2.75S448.86,278.43,449,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M447.5,274a.64.64,0,0,1,.66.65c0,.35-3.76,1.39-3.76,1.39s1.11-.93,1.49-1.2A6.43,6.43,0,0,1,447.5,274Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M461.76,386.5l-3-102.45h0a2.52,2.52,0,0,0-1.42-2.46,5,5,0,0,0-3.89-.57,3.49,3.49,0,0,0-2.93,3h0l-3,102.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M454.62,284.45c4.29,0,4.25,1.54,4.25,3.43l-.11-4.71c0-1.84.09-3.33-4.12-3.33s-4.13,1.49-4.13,3.33l-.13,4.71C450.38,286,450.34,284.45,454.62,284.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M459.56,386.5h-4.31l.12-102.35c0-1.82,0-3.29,1.25-3.29s1.24,1.47,1.24,3.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M449.45,386.5h2.21l.73-101.79c0-1.81,0-3.28-.65-3.28s-.63,1.47-.63,3.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 443.47,
    y: 381.6,
    width: 22.14,
    height: 4.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 446.35,
    y: 381.6,
    width: 3.39,
    height: 4.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 457.48,
    y: 381.6,
    width: 5.2,
    height: 4.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M273.14,117.14l9.76,2.17,22.13,6.8,5.49-.38s4.35-4.61,4.78-10.51-5.21-8.07-5.21-8.07l-34.15-8.26s-4.54,3.48-4.54,7S273.14,117.14,273.14,117.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.3,115.22c.43-5.9-5.21-8.07-5.21-8.07l-34.15-8.26s-4.54,3.48-4.54,7C282.19,109.15,301.28,110.35,315.3,115.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.84,108.8c-.65,4.36-3,7.62-5.27,7.28s-3.55-4.15-2.9-8.52,3-7.62,5.28-7.28S277.5,104.43,276.84,108.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M273.14,117.14l9.76,2.17,22.13,6.8,5.49-.38s-3.11-9.12-39.12-19.89C271.4,109.32,273.14,117.14,273.14,117.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "269.39 105.68 255.19 61.87 197.7 0 194.16 2.41 265.85 108.08 269.39 105.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 229.63,
    y: -9.81,
    width: 4.28,
    height: 127.7,
    transform: "matrix(0.83, -0.56, 0.56, 0.83, 9.63, 139.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "209.95 13.18 204.15 17.12 200.76 12.13 205.8 8.71 209.95 13.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "201.85 4.47 197.54 7.39 194.16 2.41 197.7 0 201.85 4.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "268.32 107.9 313.36 117.51 395.68 98.66 395.37 94.39 268 103.64 268.32 107.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 267.99,
    y: 99.01,
    width: 127.7,
    height: 4.28,
    transform: "translate(-6.45 24.28) rotate(-4.15)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "378.14 102.68 377.64 95.68 383.64 95.24 384.07 101.31 378.14 102.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "389.74 100.02 389.36 94.82 395.37 94.39 395.68 98.66 389.74 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "266.93 105.86 236.08 140.07 211.24 220.78 215.1 222.65 270.78 107.72 266.93 105.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 177.16,
    y: 162.12,
    width: 127.71,
    height: 4.28,
    transform: "translate(-11.9 309.52) rotate(-64.15)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "216.53 203.59 222.85 206.63 220.22 212.07 214.75 209.41 216.53 203.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "213.03 214.96 217.73 217.23 215.1 222.65 211.24 220.78 213.03 214.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M273.58,108c.48-4.48-.61-9.29-3.87-8.42s-9.13,5.22-8.92,6.74,4.54,5.59,7.89,7S273.18,111.53,273.58,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M269.74,100.25a1.65,1.65,0,0,1,1.66,1.67c0,.89-9.55,3.54-9.55,3.54s2.81-2.37,3.79-3A16.59,16.59,0,0,1,269.74,100.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306,386.5l-7.61-260.66h0a6.39,6.39,0,0,0-3.61-6.26,12.72,12.72,0,0,0-9.9-1.44,8.83,8.83,0,0,0-7.45,7.7h0L269.74,386.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M287.86,126.86c10.9,0,10.8,3.91,10.8,8.73l-.3-12c0-4.67.26-8.45-10.45-8.45s-10.52,3.78-10.52,8.45l-.33,12C277.06,130.77,277,126.86,287.86,126.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M300.4,386.5h-11l.32-260.41c0-4.62-.06-8.36,3.17-8.36s3.17,3.74,3.17,8.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M274.69,386.5h5.63l1.84-259c0-4.61,0-8.33-1.64-8.33s-1.62,3.72-1.62,8.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.48,
    y: 374.02,
    width: 56.31,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 266.8,
    y: 374.02,
    width: 8.62,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 295.12,
    y: 374.02,
    width: 13.22,
    height: 12.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381.43,209.68l6.4,1.42,14.53,4.47,3.61-.26a12.73,12.73,0,0,0,3.14-6.9c.28-3.87-3.43-5.3-3.43-5.3l-22.42-5.42s-3,2.28-3,4.57A51.58,51.58,0,0,0,381.43,209.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M409.11,208.41c.28-3.87-3.43-5.3-3.43-5.3l-22.42-5.42s-3,2.28-3,4.57C387.37,204.43,399.9,205.22,409.11,208.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M383.85,204.2c-.43,2.86-2,5-3.45,4.78s-2.33-2.73-1.91-5.59,2-5,3.47-4.78S384.28,201.33,383.85,204.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M381.43,209.68l6.4,1.42,14.53,4.47,3.61-.26s-2-6-25.68-13.05A51.58,51.58,0,0,0,381.43,209.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M403,386.5l-5-171.12h0a4.2,4.2,0,0,0-2.37-4.1,8.35,8.35,0,0,0-6.5-.95,5.78,5.78,0,0,0-4.89,5h0l-5,171.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M391.09,216.05c7.15,0,7.08,2.57,7.08,5.74L398,213.9c0-3.06.16-5.55-6.87-5.55s-6.9,2.49-6.9,5.55l-.22,7.89C384,218.62,383.93,216.05,391.09,216.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M399.32,386.5h-7.19l.21-170.95c0-3,0-5.49,2.08-5.49s2.07,2.46,2.07,5.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M382.44,386.5h3.7l1.21-170c0-3,0-5.47-1.07-5.47s-1.07,2.45-1.07,5.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 372.46,
    y: 378.31,
    width: 36.96,
    height: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 377.26,
    y: 378.31,
    width: 5.66,
    height: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 395.86,
    y: 378.31,
    width: 8.68,
    height: 8.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "378.72 203.75 405.52 217.74 460.91 220.26 461.46 217.51 379.27 201 378.72 203.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 418.68,
    y: 168.71,
    width: 2.81,
    height: 83.83,
    transform: "translate(130.83 580.99) rotate(-78.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "449.11 219.72 450.02 215.21 453.9 215.99 453.11 219.91 449.11 219.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "456.91 220.08 457.59 216.73 461.46 217.51 460.91 220.26 456.91 220.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "378.2 202.21 352.68 218.43 322.8 265.13 324.91 266.99 380.31 204.07 378.2 202.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 309.64,
    y: 233.19,
    width: 83.83,
    height: 2.81,
    transform: "translate(-56.84 343.42) rotate(-48.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "329.17 255.19 332.63 258.23 330.01 261.19 327.01 258.55 329.17 255.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "324.96 261.76 327.53 264.02 324.91 266.99 322.8 265.13 324.96 261.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "379.79 202.53 378.5 172.32 353 123.09 350.34 123.99 377.12 203.43 379.79 202.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 363.66,
    y: 121.34,
    width: 2.81,
    height: 83.83,
    transform: "translate(-33.03 125.2) rotate(-18.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "358.44 133.58 354.07 135.05 352.81 131.31 356.59 130.03 358.44 133.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "354.84 126.64 351.6 127.74 350.34 123.99 353 123.09 354.84 126.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M381.71,203.65c.32-2.94-.39-6.1-2.53-5.53s-6,3.43-5.86,4.42,3,3.68,5.18,4.58S381.45,206,381.71,203.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M379.2,198.59a1.08,1.08,0,0,1,1.09,1.09c0,.59-6.27,2.32-6.27,2.32s1.84-1.56,2.48-2A10.86,10.86,0,0,1,379.2,198.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Buidings"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 558.25,
    y: 292.39,
    width: 3.38,
    height: 23.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 561.63,
    y: 292.39,
    width: 3.38,
    height: 23.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 550.47,
    y: 276.09,
    width: 3.38,
    height: 35.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 547.09,
    y: 276.09,
    width: 3.38,
    height: 35.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "619.06 376.41 546.78 373.93 546.78 386.5 619.06 386.5 619.06 376.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "470.21 376.56 546.78 373.93 546.78 305.5 470.21 322.42 470.21 339.71 471.97 340.18 471.97 358.34 470.21 359.08 470.21 376.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "546.78 305.5 546.78 373.93 623.35 376.56 623.35 359.15 621.92 358.37 621.92 340.23 623.35 339.86 623.35 322.47 546.78 305.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "621.92 340.23 546.78 328.3 546.78 351.12 621.92 358.37 621.92 340.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "471.97 340.18 471.97 358.34 546.78 351.12 546.78 328.3 471.97 340.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "475.71 376.37 546.78 373.93 546.78 386.5 475.71 386.5 475.71 376.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "471.97 340.18 470.21 339.71 546.78 326.1 623.35 339.86 621.92 340.23 546.78 328.3 471.97 340.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M604.2,356.66,618.52,358V339.7l-14.32-2.28Zm-22.51-2.17,17.57,1.69V336.65l-17.57-2.81ZM555,351.91l20.92,2v-21L555,329.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 620.3,
    y: 319.42,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 618.59,
    y: 319.42,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 579.11,
    y: 310.88,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 577.4,
    y: 310.88,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 552.07,
    y: 325.96,
    width: 1.71,
    height: 26.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 550.36,
    y: 325.96,
    width: 1.71,
    height: 26.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 602.17,
    y: 334.76,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 600.46,
    y: 334.76,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M475,339.7V358l22.44-2.16V336.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "623.35 322.47 623.35 376.56 577.54 374.95 602.21 317.78 623.35 322.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "470.21 322.42 509.38 314.39 470.21 376.56 470.21 322.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "512.08 337.7 509.87 343.07 512.75 342.51 509.36 349.48 509.96 349.59 508.38 350.98 507.94 349.24 508.52 349.34 510.26 344.26 507.71 344.67 510.02 338.23 512.08 337.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 375.92,
    y: 292.39,
    width: 3.37,
    height: 23.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 379.29,
    y: 292.39,
    width: 3.38,
    height: 23.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 368.13,
    y: 276.09,
    width: 3.38,
    height: 35.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 364.75,
    y: 276.09,
    width: 3.38,
    height: 35.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "436.72 376.41 364.44 373.93 364.44 386.5 436.72 386.5 436.72 376.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "287.87 376.56 364.44 373.93 364.44 305.5 287.87 322.42 287.87 339.71 289.63 340.18 289.63 358.34 287.87 359.08 287.87 376.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "364.44 305.5 364.44 373.93 441.01 376.56 441.01 359.15 439.58 358.37 439.58 340.23 441.01 339.86 441.01 322.47 364.44 305.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "439.58 340.23 364.44 328.3 364.44 351.11 439.58 358.37 439.58 340.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "289.63 340.18 289.63 358.34 364.44 351.11 364.44 328.3 289.63 340.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "293.38 376.37 364.44 373.93 364.44 386.5 293.38 386.5 293.38 376.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "289.63 340.18 287.87 339.71 364.44 326.1 441.01 339.86 439.58 340.23 364.44 328.3 289.63 340.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "334.79 374.95 321.79 375.39 321.79 335.07 334.79 336.64 334.79 374.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "358.69 329.21 334.79 333.01 334.79 374.95 358.69 374.13 358.69 329.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "358.69 339.12 348.99 340.39 348.99 373.36 358.69 373.01 358.69 339.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "358.69 329.21 352.36 328.24 317.19 334.5 321.79 335.07 334.79 336.64 358.69 333.11 358.69 329.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "336.38 342.08 336.38 373.85 347.33 373.44 347.33 340.64 336.38 342.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "342.94 326.83 306.42 333.14 321.79 335.07 358.69 329.21 342.94 326.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "352.36 325.21 342.94 323.69 342.94 326.83 352.36 328.24 352.36 325.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "306.42 330.33 342.94 323.69 342.94 326.83 306.42 333.14 306.42 330.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "316.99 380.79 351.55 380.22 351.55 373.89 316.95 375.13 316.99 380.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "351.55 373.89 351.55 380.22 345.19 380.11 345.19 386.5 358.69 386.5 358.69 380.34 358.69 374.13 351.55 373.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "311.44 380.79 345.19 380.11 345.19 386.5 311.44 386.5 311.44 380.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M351.73,358.74a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,351.73,358.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M347,359.08a1.46,1.46,0,1,1-1.46-1.46A1.47,1.47,0,0,1,347,359.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M421.86,356.66,436.18,358V339.7l-14.32-2.28Zm-22.51-2.17,17.57,1.69V336.65l-17.57-2.81Zm-26.72-2.58,20.93,2v-21l-20.93-3.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 437.96,
    y: 319.42,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 436.25,
    y: 319.42,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 396.77,
    y: 310.88,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 395.06,
    y: 310.88,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 369.73,
    y: 325.96,
    width: 1.71,
    height: 26.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 368.02,
    y: 325.96,
    width: 1.71,
    height: 26.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 419.83,
    y: 334.76,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 418.12,
    y: 334.76,
    width: 1.71,
    height: 22.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M292.7,339.7V358l22.45-2.16V336.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "441.01 322.47 441.01 376.56 395.2 374.95 419.87 317.78 441.01 322.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "287.87 322.42 327.04 314.39 287.87 376.56 287.87 322.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "321.81 335.07 334.81 336.64 334.81 358.37 321.81 335.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trees"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M481,368.19a5.21,5.21,0,0,0-5.68-.91,10.16,10.16,0,0,0-8.34-7.42,10.39,10.39,0,0,0,1.88-6.29,10.06,10.06,0,0,0-20.12-.39,9.88,9.88,0,0,0-3.66-.6,10.19,10.19,0,0,0-9.78,10.59,11,11,0,0,0,.64,3.32,10.52,10.52,0,0,0-1.31,5.36,10.19,10.19,0,0,0,10.36,10,9.88,9.88,0,0,0,4.79-1.4,3.08,3.08,0,0,0,.25.27,6.38,6.38,0,0,0,10.08-2.06,9.84,9.84,0,0,0,9.37.91,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,4,4,0,0,0,.88-3.85,5.4,5.4,0,0,0,4.29-1.72A5.29,5.29,0,0,0,481,368.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M456.54,384.56c-.06.77-.08,1.37-.09,1.94h6.39a94.54,94.54,0,0,0,10.68-10.06c-1.3,1.44-6.82,4.92-7.92,6-.51-.3.57-3.46.64-5.83,0,0-2.5,4.4-1.72,6.65A34.07,34.07,0,0,1,460,386c-.29-3.64-.52-6.15-.7-7.88-.05-.43,4.25-8.11,4-7.84-1.77,2.24-2.58,2.64-4.07,5.28-.48.84-1.61-6.75-1.61-6.75-.61.49.08,5.67-.15,6.83a19.47,19.47,0,0,0-.28,2.55c-.07,1.06-.23,3.58-.36,4.64-1.12-.26-3.3-2.79-6-7.73C450.84,375.07,452.93,383.52,456.54,384.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M455.72,386.5h2.88c-3.26-1.52-13.75-4.2-17.57-7.36C441,379.14,442.54,383,455.72,386.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M461.83,349.82A1.87,1.87,0,1,1,460,348,1.87,1.87,0,0,1,461.83,349.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M457.43,348.94a.88.88,0,0,1-1.76,0,.88.88,0,0,1,1.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M478,368.77a.88.88,0,1,1-.88-.88A.87.87,0,0,1,478,368.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M445,381.88a9.88,9.88,0,0,0,4.79-1.4,3.08,3.08,0,0,0,.25.27,6.38,6.38,0,0,0,10.08-2.06,9.84,9.84,0,0,0,9.37.91,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,4,4,0,0,0,.88-3.85,5.4,5.4,0,0,0,4.29-1.72,5.31,5.31,0,0,0,.58-6.57,12.48,12.48,0,0,1-2.6,4.37c-1.8,1.5-3.78-1.85-5.61-3.65s-2.67.18-5.19,1.45-5-1-8.82-2.22-10.45,4.19-12.61,4.92-5.4,2.69-9.36.89a7.92,7.92,0,0,1-2.88-2.19A10.16,10.16,0,0,0,445,381.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M467.3,368.39a2.16,2.16,0,1,1-2.15-2.15A2.15,2.15,0,0,1,467.3,368.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M442.85,365.93a1.82,1.82,0,1,1-1.82-1.81A1.82,1.82,0,0,1,442.85,365.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M469.93,367.75a1,1,0,1,1-1-1A1,1,0,0,1,469.93,367.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M438.39,365.77a1,1,0,1,1-1-1A1,1,0,0,1,438.39,365.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M443.88,363a1,1,0,1,1-1-1A1,1,0,0,1,443.88,363Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M458.46,343.54a10.16,10.16,0,0,0-9.75,9.64,9.76,9.76,0,0,0-3.67-.6,10,10,0,0,0-8.75,5.75c4.35-3.24,11.14-2.31,14.44-1.59a.64.64,0,0,0,.62-1l-1-1.19a1.11,1.11,0,0,1-.12-1.31c1.46-2.45,6.94-10,16.75-5.31A10,10,0,0,0,458.46,343.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M467,359.83a20.68,20.68,0,0,0-9.53,3.68,37.17,37.17,0,0,1,12.16-1.23,16.08,16.08,0,0,1,3.44.87,10,10,0,0,0-6.09-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M456,374a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,456,374Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M456.55,370.8a.88.88,0,1,1-1.76,0,.88.88,0,0,1,1.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M654.21,352.52a11.56,11.56,0,0,0-.79-19.13,14.64,14.64,0,0,0-14.06-14.58,14,14,0,0,0-5.27.86,14.49,14.49,0,0,0-29,.56,15,15,0,0,0,2.69,9,.08.08,0,0,0,0,.05,14.74,14.74,0,0,0-12.51,14.28,15.22,15.22,0,0,0,.27,3.26,6.07,6.07,0,0,0,.71,7.41,6.18,6.18,0,0,0,3.79,1.93,11.45,11.45,0,0,0,22.4,1.82,9.23,9.23,0,0,0,7.68-.89,14.21,14.21,0,0,0,16.26,2.3,5.21,5.21,0,1,0,7.81-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M627.94,367.19a40.48,40.48,0,0,0-.08-4.46c4.12-1.41,6.51-12.81,6.51-12.81-3.1,6.66-5.59,10.07-6.88,10.43-.14-1.43-.32-4.83-.4-6.26a31.82,31.82,0,0,0-.32-3.45c-.26-1.56.53-8.56-.17-9.22,0,0-1.29,10.25-1.83,9.11-1.7-3.56-2.63-4.1-4.65-7.12-.25-.37,4.65,10,4.6,10.58-.21,2.34-.47,5.73-.8,10.64a38.73,38.73,0,0,1-5.16-3.62c.89-3-2-9-2-9,.08,3.21,1.31,7.48.73,7.87-1.25-1.49-7.55-6.2-9-8.14,0,0,8.81,11.56,15.2,16-.3,3.75-.41,9.93-.57,11.13-.32,2.5-.82,5.4-1.33,7.58h7.47c-.13-1.08-.4-2.12-.43-3.28-.05-2.31-.11-10.44-.38-12.06,9.3-4.62,17.1-15.75,17.1-15.75C638.87,361.94,630.71,367,627.94,367.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M617.82,310.18c6.68-1.51,9.37-.19,13.69,1.94A14.36,14.36,0,0,0,620,305.8a14.66,14.66,0,0,0-14.91,14.43,15,15,0,0,0,2.69,9,.08.08,0,0,0,0,.05,14.74,14.74,0,0,0-12.51,14.28,15.33,15.33,0,0,0,.1,2.15c1.26-2.79,7.12-13.16,15.54-11.24,5.14,1.17,6.22,1,9-.87,1-.67,0-1.06-4.21-2.39C606.5,328.36,605.19,313.05,617.82,310.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M628,322.43c-1.53,2.11.22,2.24,4.31,1.15a35.18,35.18,0,0,1,11-1.33c1.49.12,5,.91,6,.94a14.15,14.15,0,0,0-9.87-4.38,14,14,0,0,0-5.27.86S629.49,320.33,628,322.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M658.9,343.22a11.53,11.53,0,0,0-5.48-9.83,15,15,0,0,0-.59-3.94,6.38,6.38,0,0,1-3.63,2.93c-4,1.22-1.53,3.32-1.53,3.32s5.36,9.24-3.44,14.54c-3.71,2.24-9.24,2.7-13.91,1.6-5.55-1.31-10.2-8.43-10.2-8.43s.89,10.09-9.19,12.83c-4.77,1.3-9.64-3.45-9.64-3.45a13,13,0,0,1-3.37.33l-2.45,0a6.57,6.57,0,0,0,.8,1.1,6.18,6.18,0,0,0,3.79,1.93,11.45,11.45,0,0,0,22.4,1.82,9.23,9.23,0,0,0,7.68-.89,14.21,14.21,0,0,0,16.26,2.3,5.21,5.21,0,1,0,7.81-6.89A11.54,11.54,0,0,0,658.9,343.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M646.36,344.94a3.14,3.14,0,1,1-3.14-3.14A3.14,3.14,0,0,1,646.36,344.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M640,348.08a2,2,0,1,1-2-2A2,2,0,0,1,640,348.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M608.49,351.41a2,2,0,1,1-2-2A2,2,0,0,1,608.49,351.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M645.21,339.88a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,645.21,339.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M611.42,347.89a1.47,1.47,0,1,1-1.46-1.46A1.46,1.46,0,0,1,611.42,347.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M651.2,354.78a2,2,0,1,1-2-2A2,2,0,0,1,651.2,354.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M653,351.57a1.28,1.28,0,1,1-1.28-1.28A1.28,1.28,0,0,1,653,351.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M616.32,316.81a2,2,0,1,1-2-2A2,2,0,0,1,616.32,316.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M611,338.42a3.25,3.25,0,1,1-3.25-3.25A3.25,3.25,0,0,1,611,338.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M617.39,313.19a.94.94,0,1,1-.93-.94A.93.93,0,0,1,617.39,313.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M627.69,325.76a.94.94,0,0,1-1.87,0,.94.94,0,1,1,1.87,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M624.37,369.31v-1.4l-.7.18c-.28,3.77-.4,9.66-.55,10.83-.32,2.5-.82,5.4-1.33,7.58h1.64l.94-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M681.11,368.19a5.22,5.22,0,0,0-5.69-.91,10.16,10.16,0,0,0-8.34-7.42,10.39,10.39,0,0,0,1.88-6.29,10.06,10.06,0,0,0-20.11-.39,9.94,9.94,0,0,0-3.66-.6,10.19,10.19,0,0,0-9.78,10.59,10.69,10.69,0,0,0,.63,3.32,10.52,10.52,0,0,0-1.31,5.36,10.2,10.2,0,0,0,10.37,10,9.84,9.84,0,0,0,4.78-1.4l.25.27a6.37,6.37,0,0,0,10.08-2.06,9.89,9.89,0,0,0,5.81,1.69,9.78,9.78,0,0,0,3.56-.78,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,3.92,3.92,0,0,0,.88-3.85,5.37,5.37,0,0,0,4.29-1.72A5.3,5.3,0,0,0,681.11,368.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M656.68,384.56c-.06.77-.08,1.37-.09,1.94H663a94.08,94.08,0,0,0,10.69-10.06c-1.31,1.44-6.83,4.92-7.93,6-.51-.3.57-3.46.65-5.83,0,0-2.51,4.4-1.73,6.65a34.07,34.07,0,0,1-4.52,2.68c-.29-3.64-.52-6.15-.7-7.88-.05-.43,4.25-8.11,4-7.84-1.77,2.24-2.58,2.64-4.07,5.28-.48.84-1.61-6.75-1.61-6.75-.61.49.08,5.67-.15,6.83a21.36,21.36,0,0,0-.28,2.55c-.07,1.06-.22,3.58-.35,4.64-1.13-.26-3.31-2.79-6-7.73C651,375.07,653.08,383.52,656.68,384.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M655.87,386.5h2.87c-3.26-1.52-13.74-4.2-17.56-7.36C641.18,379.14,642.68,383,655.87,386.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M662,349.82A1.88,1.88,0,1,1,660.1,348,1.88,1.88,0,0,1,662,349.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M657.58,348.94a.89.89,0,1,1-.88-.88A.88.88,0,0,1,657.58,348.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M678.18,368.77a.89.89,0,1,1-.89-.88A.88.88,0,0,1,678.18,368.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M645.1,381.88a9.84,9.84,0,0,0,4.78-1.4l.25.27a6.37,6.37,0,0,0,10.08-2.06,9.89,9.89,0,0,0,5.81,1.69,9.78,9.78,0,0,0,3.56-.78,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,3.92,3.92,0,0,0,.88-3.85,5.4,5.4,0,0,0,4.88-8.29,12.79,12.79,0,0,1-2.6,4.37c-1.81,1.5-3.79-1.85-5.61-3.65s-2.68.18-5.2,1.45-5-1-8.82-2.22S649.2,373.24,647,374s-5.4,2.69-9.36.89a8.09,8.09,0,0,1-2.88-2.19A10.17,10.17,0,0,0,645.1,381.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M667.45,368.39a2.16,2.16,0,1,1-2.16-2.15A2.16,2.16,0,0,1,667.45,368.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M643,365.93a1.82,1.82,0,1,1-1.81-1.81A1.81,1.81,0,0,1,643,365.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M670.07,367.75a1,1,0,1,1-1-1A1,1,0,0,1,670.07,367.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M638.53,365.77a1,1,0,1,1-1-1A1,1,0,0,1,638.53,365.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M644,363a1,1,0,1,1-1-1A1,1,0,0,1,644,363Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M658.61,343.54a10.17,10.17,0,0,0-9.76,9.64,9.74,9.74,0,0,0-3.66-.6,10,10,0,0,0-8.75,5.75c4.35-3.24,11.13-2.31,14.43-1.59a.65.65,0,0,0,.68-.3.63.63,0,0,0-.06-.74l-1-1.19a1.11,1.11,0,0,1-.12-1.31c1.46-2.45,6.94-10,16.76-5.31A10,10,0,0,0,658.61,343.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M667.1,359.83a20.61,20.61,0,0,0-9.52,3.68,37.09,37.09,0,0,1,12.15-1.23,16.08,16.08,0,0,1,3.44.87,10,10,0,0,0-6.09-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M656.12,374a1.88,1.88,0,1,1-1.87-1.88A1.87,1.87,0,0,1,656.12,374Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M656.7,370.8a.89.89,0,1,1-1.77,0,.89.89,0,0,1,1.77,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "808.52 312.27 801.08 321.73 803.01 321.33 802.2 323.68 794.32 331.27 798.67 331.29 794.72 336.95 790.14 340.79 794.24 343.47 784.43 351.46 793.27 354.29 780.54 363.94 788.93 367.82 777.59 376.36 786.22 376.28 788.45 377.31 801.24 379.78 823.19 378.26 839.84 373.26 828.98 370 833.81 367.82 822.95 356.74 827.29 355.93 821.02 344.88 827.05 342.6 819.13 335.84 825.04 334.02 816.48 329.12 819.57 327.81 814.02 322 815.71 319.99 808.52 312.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "810.66 386.5 803.63 386.5 805.1 377.37 809.92 377.37 809.98 381.4 810.66 386.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "801.24 379.78 823.19 378.26 839.84 373.26 828.98 370 833.81 367.82 822.95 356.74 827.29 355.93 821.02 344.88 825.58 343.15 819.13 335.84 820.14 334.02 816.48 329.12 819.57 327.81 814.02 322 815.71 319.99 809.05 313.1 809.68 319.12 806.3 321.08 811.37 323.04 810.89 329.34 805.42 331.08 811.37 336.73 807.15 344.88 818.93 352.25 816.65 354.56 807.25 357.46 813.99 366.54 821.02 371.21 788.15 377.23 788.45 377.31 801.24 379.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "793.27 354.29 780.54 363.94 807.25 357.46 795.64 356.41 793.27 354.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "794.24 343.47 784.43 351.46 793.27 354.29 798.63 344.26 794.24 343.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "790.14 340.79 791.74 341.84 803.49 334.02 796.96 333.75 794.72 336.95 790.14 340.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "788.93 367.82 777.59 376.36 800.05 368.47 788.93 367.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "802.39 323.15 802.2 323.68 794.32 331.27 795.64 331.27 805.78 323.15 802.39 323.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "802.3 321.48 806.38 318.23 808.52 312.27 801.08 321.73 802.3 321.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "805.08 386.5 805.78 377.37 805.1 377.37 803.63 386.5 805.08 386.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "797.31 342.85 799.94 340.82 799.94 342.57 797.31 342.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "811.04 341.84 813.68 339.8 813.68 341.56 811.04 341.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "804.02 328.71 804.02 330.55 805.39 329.63 804.02 328.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "795.64 352.25 798.63 352.25 798.63 349.91 795.64 352.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "810.28 320.91 813.27 320.91 813.27 318.57 810.28 320.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "817.76 348.48 820.74 348.48 820.74 346.14 817.76 348.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "795.81 366.64 792.88 364.08 791.45 365.96 795.81 366.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "797.65 372.09 796.04 374.65 793.63 374.65 797.65 372.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "802.55 330.6 800.98 331.95 799.61 330.6 802.55 330.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "803.72 354.12 806.34 353.45 803.07 352.1 803.72 354.12"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "829.39 367.62 826.49 367.62 829.39 369.4 829.39 367.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "814.67 359.11 811.77 359.11 814.67 360.89 814.67 359.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "820.7 375.04 817.8 375.04 820.7 376.82 820.7 375.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "821.02 354.29 817.48 355.18 821.02 356.58 821.02 354.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "810.73 344.88 813.99 345.78 811.37 347.31 810.73 344.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "813.22 324.04 816.49 324.94 813.86 326.47 813.22 324.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "816.57 337.79 814.86 337.79 816.57 339.44 816.57 337.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M810.12,327.51a19.13,19.13,0,0,0-1.31-31.64c-.2-13.06-10.38-23.75-23.26-24.11a23.18,23.18,0,0,0-8.71,1.44,24.2,24.2,0,0,0-23.24-22.95c-13.24-.37-24.27,10.31-24.65,23.87A24.8,24.8,0,0,0,733.4,289a.2.2,0,0,0,0,.08,24.63,24.63,0,0,0-20.24,29,10,10,0,0,0,1.18,12.26,10.21,10.21,0,0,0,6.26,3.19,19,19,0,0,0,37.06,3,15.26,15.26,0,0,0,12.69-1.47,23.45,23.45,0,0,0,26.89,3.8,8.62,8.62,0,1,0,12.92-11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M766.67,351.77a67.28,67.28,0,0,0-.13-7.38c6.81-2.34,10.76-21.18,10.76-21.18-5.13,11-9.24,16.66-11.37,17.25-.23-2.37-.54-8-.66-10.35a57,57,0,0,0-.53-5.71c-.43-2.58.87-14.15-.28-15.24,0,0-2.14,16.94-3,15-2.81-5.88-4.34-6.78-7.68-11.76-.41-.62,7.69,16.53,7.6,17.49-.33,3.87-.77,9.48-1.31,17.59a63.18,63.18,0,0,1-8.53-6c1.47-5-3.26-14.85-3.26-14.85.14,5.31,2.18,12.36,1.22,13-2.08-2.47-12.49-10.26-15-13.46,0,0,14.56,19.11,25.13,26.5-.49,6.2-.68,16.42-.93,18.4-.54,4.15-1.36,8.93-2.2,12.55h12.34a54,54,0,0,1-.7-5.43c-.08-3.81-.19-17.26-.63-19.94,15.37-7.64,28.28-26,28.28-26C784.75,343.09,771.26,351.41,766.67,351.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M749.94,257.5c11-2.51,15.49-.31,22.63,3.21a23.76,23.76,0,0,0-19-10.46c-13.24-.37-24.27,10.31-24.65,23.87A24.8,24.8,0,0,0,733.4,289a.2.2,0,0,0,0,.08,24.59,24.59,0,0,0-20.52,27.16c2.09-4.61,11.78-21.74,25.71-18.57,8.49,1.94,10.27,1.63,14.87-1.43,1.68-1.13.07-1.77-7-4C731.22,287.56,729.05,262.25,749.94,257.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M766.71,277.75c-2.53,3.48.36,3.71,7.12,1.9,3.91-1,11.4-2.73,18.12-2.2,2.46.19,8.27,1.51,9.93,1.55a23.54,23.54,0,0,0-16.33-7.24,23.18,23.18,0,0,0-8.71,1.44S769.24,274.27,766.71,277.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M817.87,312.13a19.09,19.09,0,0,0-9.06-16.26,24.51,24.51,0,0,0-1-6.51,10.59,10.59,0,0,1-6,4.85c-6.65,2-2.53,5.49-2.53,5.49s8.85,15.27-5.7,24c-6.14,3.71-15.28,4.46-23,2.64-9.2-2.17-16.88-13.93-16.88-13.93s1.47,16.67-15.19,21.21c-7.89,2.15-15.94-5.71-15.94-5.71s-1.15.43-5.58.55c-1.57,0-2.93.05-4,.05a10.54,10.54,0,0,0,1.32,1.82,10.21,10.21,0,0,0,6.26,3.19,19,19,0,0,0,37.06,3,15.26,15.26,0,0,0,12.69-1.47,23.45,23.45,0,0,0,26.89,3.8,8.62,8.62,0,1,0,12.92-11.39A19.09,19.09,0,0,0,817.87,312.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M797.14,315a5.2,5.2,0,1,1-5.19-5.19A5.19,5.19,0,0,1,797.14,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M786.57,320.16a3.3,3.3,0,1,1-3.29-3.29A3.3,3.3,0,0,1,786.57,320.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M734.51,325.67a3.3,3.3,0,1,1-3.29-3.29A3.3,3.3,0,0,1,734.51,325.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M795.24,306.61a2.42,2.42,0,1,1-2.42-2.43A2.41,2.41,0,0,1,795.24,306.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M739.35,319.86a2.42,2.42,0,1,1-2.42-2.43A2.41,2.41,0,0,1,739.35,319.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M805.13,331.24a3.3,3.3,0,1,1-3.29-3.29A3.29,3.29,0,0,1,805.13,331.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M808.16,325.94a2.12,2.12,0,1,1-2.12-2.12A2.11,2.11,0,0,1,808.16,325.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M747.46,268.46a3.3,3.3,0,1,1-3.3-3.3A3.29,3.29,0,0,1,747.46,268.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M738.67,304.18a5.38,5.38,0,1,1-5.37-5.37A5.38,5.38,0,0,1,738.67,304.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M749.24,262.47a1.55,1.55,0,1,1-1.55-1.54A1.55,1.55,0,0,1,749.24,262.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M766.26,283.26a1.55,1.55,0,1,1-1.54-1.55A1.54,1.54,0,0,1,766.26,283.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M760.77,355.28V353l-1.16.3c-.47,6.24-.66,16-.9,17.9-.54,4.15-1.36,8.93-2.2,12.55h2.71l1.55-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M560.13,368.19a5.22,5.22,0,0,0-5.69-.91,10.16,10.16,0,0,0-8.34-7.42,10.44,10.44,0,0,0,1.89-6.29,10.06,10.06,0,0,0-20.12-.39,9.94,9.94,0,0,0-3.66-.6,10.2,10.2,0,0,0-9.79,10.59,11,11,0,0,0,.64,3.32,10.52,10.52,0,0,0-1.31,5.36,10.2,10.2,0,0,0,10.37,10,9.84,9.84,0,0,0,4.78-1.4c.09.09.15.18.25.27a6.37,6.37,0,0,0,10.08-2.06,9.84,9.84,0,0,0,9.37.91,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,4,4,0,0,0,.88-3.85,5.37,5.37,0,0,0,4.29-1.72A5.3,5.3,0,0,0,560.13,368.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M535.7,384.56c-.06.77-.08,1.37-.09,1.94H542a93.57,93.57,0,0,0,10.68-10.06c-1.3,1.44-6.82,4.92-7.92,6-.51-.3.57-3.46.65-5.83,0,0-2.51,4.4-1.73,6.65a34.07,34.07,0,0,1-4.52,2.68c-.29-3.63-.52-6.15-.7-7.88-.05-.43,4.25-8.11,4-7.83-1.77,2.23-2.58,2.63-4.07,5.27-.48.84-1.61-6.75-1.61-6.75-.61.49.08,5.67-.15,6.83a21.36,21.36,0,0,0-.28,2.55c-.07,1.06-.23,3.58-.36,4.64-1.12-.26-3.3-2.79-6-7.73C530,375.07,532.09,383.52,535.7,384.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M534.88,386.5h2.88c-3.26-1.52-13.74-4.2-17.57-7.36C520.19,379.14,521.7,383,534.88,386.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M541,349.82a1.88,1.88,0,1,1-1.88-1.87A1.88,1.88,0,0,1,541,349.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M536.59,348.94a.88.88,0,0,1-1.76,0,.88.88,0,0,1,1.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M557.19,368.77a.88.88,0,1,1-.88-.88A.87.87,0,0,1,557.19,368.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M524.12,381.88a9.84,9.84,0,0,0,4.78-1.4c.09.09.15.18.25.27a6.37,6.37,0,0,0,10.08-2.06,9.84,9.84,0,0,0,9.37.91,3.74,3.74,0,0,0,1.09,1.9,3.87,3.87,0,0,0,5.45-.26,4,4,0,0,0,.88-3.85,5.4,5.4,0,0,0,4.88-8.29,12.64,12.64,0,0,1-2.61,4.37c-1.8,1.49-3.78-1.85-5.61-3.65s-2.67.18-5.19,1.45-5-1-8.82-2.22-10.45,4.19-12.61,4.92-5.4,2.69-9.36.89a7.92,7.92,0,0,1-2.88-2.19A10.17,10.17,0,0,0,524.12,381.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M546.47,368.39a2.16,2.16,0,1,1-2.16-2.15A2.16,2.16,0,0,1,546.47,368.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M522,365.93a1.82,1.82,0,1,1-1.82-1.81A1.81,1.81,0,0,1,522,365.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M549.09,367.75a1,1,0,1,1-1-1A1,1,0,0,1,549.09,367.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M517.55,365.77a1,1,0,1,1-1-1A1,1,0,0,1,517.55,365.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M523,363a1,1,0,1,1-1-1A1,1,0,0,1,523,363Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M537.63,343.54a10.18,10.18,0,0,0-9.77,9.64,9.66,9.66,0,0,0-3.65-.6,10,10,0,0,0-8.75,5.75c4.35-3.24,11.13-2.31,14.43-1.59a.62.62,0,0,0,.68-.3.63.63,0,0,0-.06-.74l-1-1.18a1.13,1.13,0,0,1-.12-1.32c1.46-2.45,6.94-10,16.75-5.31A10,10,0,0,0,537.63,343.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M546.12,359.83a20.63,20.63,0,0,0-9.53,3.69,37,37,0,0,1,12.16-1.24,16.08,16.08,0,0,1,3.44.87,10,10,0,0,0-6.09-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M535.14,374a1.88,1.88,0,1,1-1.87-1.88A1.87,1.87,0,0,1,535.14,374Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M535.71,370.8a.88.88,0,1,1-.88-.87A.87.87,0,0,1,535.71,370.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M297,368.19a5.22,5.22,0,0,0-5.69-.91,10.16,10.16,0,0,0-8.34-7.42,10.44,10.44,0,0,0,1.89-6.29,10.06,10.06,0,0,0-20.12-.39,9.88,9.88,0,0,0-3.66-.6,10.19,10.19,0,0,0-9.78,10.59,10.41,10.41,0,0,0,.64,3.32,10.42,10.42,0,0,0-1.31,5.36,10.19,10.19,0,0,0,10.36,10,9.84,9.84,0,0,0,4.78-1.4l.25.27a6.36,6.36,0,0,0,9-.4,6.6,6.6,0,0,0,1.11-1.66,9.84,9.84,0,0,0,9.37.91,3.66,3.66,0,0,0,1.08,1.9,3.87,3.87,0,0,0,5.45-.26,3.92,3.92,0,0,0,.88-3.85,5.37,5.37,0,0,0,4.29-1.72A5.29,5.29,0,0,0,297,368.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M272.59,384.56c-.06.77-.08,1.37-.08,1.94h6.38a94.08,94.08,0,0,0,10.69-10.06c-1.3,1.44-6.83,4.92-7.93,6-.51-.3.57-3.46.65-5.83,0,0-2.51,4.4-1.73,6.65a34.07,34.07,0,0,1-4.52,2.68c-.29-3.63-.52-6.15-.7-7.88,0-.43,4.25-8.11,4-7.83-1.77,2.23-2.58,2.63-4.07,5.27-.47.84-1.61-6.75-1.61-6.75-.61.49.08,5.67-.15,6.83a23.65,23.65,0,0,0-.28,2.55c-.06,1.06-.22,3.58-.35,4.64-1.13-.26-3.31-2.79-6-7.73C266.89,375.07,269,383.52,272.59,384.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M271.78,386.5h2.87c-3.25-1.52-13.74-4.2-17.56-7.36C257.09,379.14,258.59,383,271.78,386.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M277.89,349.82A1.88,1.88,0,1,1,276,348,1.88,1.88,0,0,1,277.89,349.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M273.49,348.94a.88.88,0,1,1-.88-.88A.88.88,0,0,1,273.49,348.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M294.09,368.77a.88.88,0,1,1-.88-.88A.88.88,0,0,1,294.09,368.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M261,381.88a9.84,9.84,0,0,0,4.78-1.4l.25.27a6.36,6.36,0,0,0,9-.4,6.6,6.6,0,0,0,1.11-1.66,9.84,9.84,0,0,0,9.37.91,3.66,3.66,0,0,0,1.08,1.9,3.87,3.87,0,0,0,5.45-.26,3.92,3.92,0,0,0,.88-3.85,5.4,5.4,0,0,0,4.88-8.29,12.79,12.79,0,0,1-2.6,4.37c-1.8,1.49-3.78-1.85-5.61-3.65s-2.67.18-5.2,1.45-5-1-8.82-2.22S265.12,373.24,263,374s-5.4,2.69-9.36.89a8.09,8.09,0,0,1-2.88-2.19A10.18,10.18,0,0,0,261,381.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M283.36,368.39a2.16,2.16,0,1,1-2.16-2.15A2.16,2.16,0,0,1,283.36,368.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M258.9,365.93a1.82,1.82,0,1,1-1.81-1.81A1.81,1.81,0,0,1,258.9,365.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M286,367.75a1,1,0,1,1-1-1A1,1,0,0,1,286,367.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M254.45,365.77a1,1,0,1,1-1-1A1,1,0,0,1,254.45,365.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M259.94,363a1,1,0,1,1-1-1A1,1,0,0,1,259.94,363Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M274.52,343.54a10.17,10.17,0,0,0-9.76,9.64,9.68,9.68,0,0,0-3.66-.6,10,10,0,0,0-8.75,5.75c4.35-3.24,11.14-2.31,14.44-1.59a.64.64,0,0,0,.61-1l-1-1.18a1.13,1.13,0,0,1-.11-1.32c1.45-2.45,6.94-10,16.75-5.31A10,10,0,0,0,274.52,343.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M283,359.83a20.56,20.56,0,0,0-9.52,3.69,37,37,0,0,1,12.15-1.24,15.94,15.94,0,0,1,3.44.87,10,10,0,0,0-6.09-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M272,374a1.88,1.88,0,1,1-1.87-1.88A1.87,1.87,0,0,1,272,374Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M272.61,370.8a.89.89,0,1,1-.88-.87A.88.88,0,0,1,272.61,370.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "442.49 295.72 433.4 307.29 435.75 306.8 434.77 309.68 425.13 318.95 430.44 318.99 425.62 325.9 420.02 330.59 425.03 333.88 413.04 343.64 423.85 347.1 408.27 358.91 418.54 363.66 404.67 374.1 415.22 374 417.95 375.26 433.59 378.28 460.44 376.42 480.8 370.31 467.52 366.31 473.42 363.66 460.14 350.1 465.45 349.11 457.78 335.6 465.16 332.81 455.47 324.55 462.7 322.32 452.23 316.33 456.01 314.73 449.23 307.62 451.29 305.16 442.49 295.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "445.12 386.5 436.52 386.5 438.31 375.33 444.21 375.33 444.28 380.26 445.12 386.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "433.59 378.28 460.44 376.42 480.8 370.31 467.52 366.31 473.42 363.66 460.14 350.1 465.45 349.11 457.78 335.6 463.36 333.49 455.47 324.55 456.71 322.32 452.23 316.33 456.01 314.73 449.23 307.62 451.29 305.16 443.14 296.74 443.92 304.1 439.78 306.49 445.98 308.9 445.39 316.59 438.7 318.72 445.98 325.63 440.81 335.6 455.22 344.61 452.44 347.43 440.94 350.98 449.19 362.09 457.78 367.8 417.58 375.16 417.95 375.26 433.59 378.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "423.85 347.1 408.27 358.91 440.94 350.98 426.74 349.7 423.85 347.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "425.03 333.88 413.04 343.64 423.85 347.1 430.39 334.84 425.03 333.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "420.02 330.59 421.98 331.88 436.34 322.32 428.35 321.99 425.62 325.9 420.02 330.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "418.54 363.66 404.67 374.1 432.14 364.45 418.54 363.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "434.99 309.03 434.77 309.68 425.13 318.95 426.74 318.96 439.14 309.03 434.99 309.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "434.89 306.98 439.88 303 442.49 295.72 433.4 307.29 434.89 306.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "438.29 386.5 439.14 375.33 438.31 375.33 436.52 386.5 438.29 386.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "428.79 333.12 432 330.63 432 332.78 428.79 333.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "445.58 331.88 448.8 329.39 448.8 331.54 445.58 331.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "436.99 315.82 436.99 318.07 438.67 316.95 436.99 315.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "426.74 344.61 430.39 344.61 430.39 341.75 426.74 344.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "444.65 306.28 448.3 306.28 448.3 303.42 444.65 306.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "453.79 340 457.44 340 457.44 337.14 453.79 340"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "426.95 362.21 423.36 359.08 421.62 361.38 426.95 362.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "429.2 368.88 427.24 372.01 424.29 372.01 429.2 368.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "435.19 318.14 433.27 319.79 431.6 318.14 435.19 318.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "436.62 346.9 439.83 346.08 435.83 344.43 436.62 346.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "468.01 363.41 464.47 363.41 468.01 365.58 468.01 363.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "450.01 353 446.47 353 450.01 355.18 450.01 353"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "457.39 372.49 453.85 372.49 457.39 374.66 457.39 372.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "457.78 347.1 453.45 348.19 457.78 349.91 457.78 347.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "445.19 335.6 449.19 336.7 445.98 338.58 445.19 335.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "448.24 310.12 452.24 311.22 449.03 313.09 448.24 310.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "452.34 326.93 450.24 326.93 452.34 328.94 452.34 326.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M259.59,345.6a15.14,15.14,0,0,0-1-25.05,19.18,19.18,0,0,0-18.42-19.09,18.41,18.41,0,0,0-6.89,1.14,19,19,0,0,0-37.92.73,19.59,19.59,0,0,0,3.53,11.8.16.16,0,0,0,0,.07,19.29,19.29,0,0,0-16.37,18.69,20.08,20.08,0,0,0,.35,4.27,8,8,0,0,0,.94,9.7,8,8,0,0,0,4.95,2.53A15,15,0,0,0,218,352.77a12.12,12.12,0,0,0,10.05-1.16,18.59,18.59,0,0,0,21.29,3,6.82,6.82,0,1,0,10.22-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M225.2,364.81a56.41,56.41,0,0,0-.1-5.85c5.39-1.85,8.51-16.77,8.51-16.77-4.06,8.72-7.31,13.19-9,13.66-.19-1.88-.43-6.33-.53-8.2a44.34,44.34,0,0,0-.42-4.51c-.34-2,.69-11.21-.22-12.07,0,0-1.7,13.41-2.41,11.92-2.22-4.66-3.43-5.37-6.08-9.32-.33-.49,6.09,13.09,6,13.86-.27,3.06-.61,7.49-1,13.92a50.78,50.78,0,0,1-6.76-4.74c1.17-4-2.57-11.75-2.57-11.75.11,4.2,1.72,9.78,1,10.3-1.64-1.95-9.89-8.12-11.83-10.65,0,0,11.52,15.13,19.89,21-.38,4.91-.54,13-.74,14.57-.42,3.28-1.07,7.07-1.74,9.93h9.77c-.16-1.42-.52-2.77-.55-4.29-.07-3-.15-13.67-.5-15.79,12.17-6.05,22.39-20.63,22.39-20.63C239.51,357.93,228.83,364.52,225.2,364.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M212,290.17c8.75-2,12.26-.25,17.92,2.54a18.8,18.8,0,0,0-15-8.28,19.21,19.21,0,0,0-19.52,18.9,19.59,19.59,0,0,0,3.53,11.8.16.16,0,0,0,0,.07,19.29,19.29,0,0,0-16.37,18.69,20,20,0,0,0,.13,2.81c1.65-3.65,9.33-17.22,20.35-14.7,6.72,1.53,8.14,1.29,11.78-1.14,1.33-.89,0-1.4-5.51-3.13C197.13,314,195.42,293.93,212,290.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M225.23,306.21c-2,2.75.29,2.93,5.64,1.5,3.09-.83,9-2.16,14.34-1.75,1.95.16,6.55,1.2,7.86,1.24a18.63,18.63,0,0,0-12.93-5.74,18.41,18.41,0,0,0-6.89,1.14S227.23,303.45,225.23,306.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M265.73,333.42a15.1,15.1,0,0,0-7.17-12.87,20,20,0,0,0-.77-5.16,8.34,8.34,0,0,1-4.75,3.84c-5.27,1.6-2,4.35-2,4.35s7,12.09-4.51,19c-4.86,2.93-12.1,3.52-18.21,2.08-7.28-1.71-13.36-11-13.36-11s1.17,13.21-12,16.8c-6.24,1.7-12.62-4.52-12.62-4.52a17,17,0,0,1-4.41.43c-1.25,0-2.32,0-3.21,0a7.69,7.69,0,0,0,1.05,1.44,8,8,0,0,0,4.95,2.53A15,15,0,0,0,218,352.77a12.12,12.12,0,0,0,10.05-1.16,18.59,18.59,0,0,0,21.29,3,6.82,6.82,0,1,0,10.22-9A15.1,15.1,0,0,0,265.73,333.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M249.32,335.67a4.11,4.11,0,1,1-4.11-4.11A4.11,4.11,0,0,1,249.32,335.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M241,339.78a2.61,2.61,0,1,1-2.61-2.61A2.61,2.61,0,0,1,241,339.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M199.74,344.14a2.61,2.61,0,1,1-2.61-2.6A2.61,2.61,0,0,1,199.74,344.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M247.82,329.05a1.92,1.92,0,1,1-1.92-1.92A1.91,1.91,0,0,1,247.82,329.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M203.57,339.54a1.92,1.92,0,1,1-1.92-1.92A1.91,1.91,0,0,1,203.57,339.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M255.65,348.55A2.61,2.61,0,1,1,253,346,2.61,2.61,0,0,1,255.65,348.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M258,344.35a1.68,1.68,0,1,1-1.67-1.67A1.68,1.68,0,0,1,258,344.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M210,298.85a2.61,2.61,0,1,1-2.61-2.61A2.6,2.6,0,0,1,210,298.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M203,327.13a4.26,4.26,0,1,1-4.25-4.25A4.25,4.25,0,0,1,203,327.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M211.39,294.11a1.23,1.23,0,1,1-1.22-1.23A1.22,1.22,0,0,1,211.39,294.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M224.88,310.56a1.23,1.23,0,1,1-1.23-1.22A1.23,1.23,0,0,1,224.88,310.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M220.53,367.59v-1.84l-.92.23c-.37,4.94-.52,12.65-.72,14.18-.42,3.28-1.07,7.07-1.74,9.93h2.15l1.23-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M191.78,372.45a3.62,3.62,0,0,0-3.93-.63,7,7,0,0,0-5.76-5.12,7.21,7.21,0,0,0,1.3-4.35,7,7,0,0,0-13.9-.26,6.81,6.81,0,0,0-2.52-.42,7,7,0,0,0-6.76,7.32,7.27,7.27,0,0,0,.44,2.29,7.2,7.2,0,0,0-.9,3.7,7,7,0,0,0,7.15,6.93,6.88,6.88,0,0,0,3.31-1,1.45,1.45,0,0,0,.17.18,4.38,4.38,0,0,0,6.2-.27,4.82,4.82,0,0,0,.77-1.15,6.78,6.78,0,0,0,6.47.63,2.46,2.46,0,0,0,.75,1.31,2.66,2.66,0,0,0,3.76-.18,2.7,2.7,0,0,0,.61-2.65,3.72,3.72,0,0,0,3-1.19A3.67,3.67,0,0,0,191.78,372.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M174.91,383.76c0,.53-.06.95-.06,1.34h4.41a64.86,64.86,0,0,0,7.37-7c-.89,1-4.71,3.4-5.47,4.16-.35-.2.4-2.38.45-4,0,0-1.73,3-1.19,4.59a23,23,0,0,1-3.13,1.85c-.2-2.51-.36-4.24-.48-5.44,0-.3,2.94-5.6,2.78-5.41a22,22,0,0,0-2.81,3.64c-.32.58-1.11-4.66-1.11-4.66-.42.34.06,3.92-.1,4.72a13.75,13.75,0,0,0-.19,1.76c0,.73-.16,2.47-.25,3.2-.78-.18-2.28-1.92-4.16-5.33C171,377.21,172.41,383,174.91,383.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M174.34,385.1h2c-2.25-1.05-9.49-2.9-12.13-5.08C164.2,380,165.23,382.65,174.34,385.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M178.56,359.77a1.3,1.3,0,1,1-1.29-1.3A1.29,1.29,0,0,1,178.56,359.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M175.52,359.16a.61.61,0,1,1-.6-.61A.6.6,0,0,1,175.52,359.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M166.9,381.91a6.88,6.88,0,0,0,3.31-1,1.45,1.45,0,0,0,.17.18,4.38,4.38,0,0,0,6.2-.27,4.82,4.82,0,0,0,.77-1.15,6.78,6.78,0,0,0,6.47.63,2.46,2.46,0,0,0,.75,1.31,2.66,2.66,0,0,0,3.76-.18,2.7,2.7,0,0,0,.61-2.65,3.72,3.72,0,0,0,3-1.19,3.68,3.68,0,0,0,.41-4.54,8.68,8.68,0,0,1-1.8,3c-1.24,1-2.61-1.28-3.88-2.52s-1.84.12-3.58,1-3.46-.7-6.09-1.54-7.22,2.9-8.71,3.4-3.73,1.86-6.47.62a5.67,5.67,0,0,1-2-1.52A7,7,0,0,0,166.9,381.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M182.34,372.59a1.49,1.49,0,1,1-1.49-1.49A1.49,1.49,0,0,1,182.34,372.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M184.16,372.15a.68.68,0,0,1-.69.68.67.67,0,0,1-.68-.68.68.68,0,0,1,.68-.69A.69.69,0,0,1,184.16,372.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M176.24,355.43a7,7,0,0,0-6.75,6.66,6.81,6.81,0,0,0-2.52-.42,6.94,6.94,0,0,0-6.05,4c3-2.24,7.7-1.6,10-1.11a.43.43,0,0,0,.47-.2.44.44,0,0,0,0-.51l-.7-.82a.77.77,0,0,1-.08-.91c1-1.69,4.79-6.92,11.57-3.67A6.91,6.91,0,0,0,176.24,355.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M182.1,366.68a14.23,14.23,0,0,0-6.58,2.54,25.71,25.71,0,0,1,8.4-.85,11,11,0,0,1,2.37.6,6.89,6.89,0,0,0-4.2-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M527.43,95.75a5.13,5.13,0,0,0-4-5.44,10.56,10.56,0,0,0-6.59.4,10.46,10.46,0,0,1,5.89.88c1,.57,3.56,6.29,3.56,6.29s6.32-1.24,8.07-.12a11.74,11.74,0,0,1,3.13,3.81s-2.21-6.42-4.13-6.67S527.43,95.75,527.43,95.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M515.27,105.83a3.27,3.27,0,0,0-4-1.47,6.73,6.73,0,0,0-3.35,2.56,6.67,6.67,0,0,1,3.44-1.63c.73-.06,4.11,2.07,4.11,2.07s2.91-2.91,4.24-2.93a7.55,7.55,0,0,1,3,.9s-3.44-2.61-4.55-2.07A13.93,13.93,0,0,0,515.27,105.83Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanEnergy);
export default __webpack_public_path__ + "static/media/CleanEnergy.654b95f8a069594d477aaaec046f7e20.svg";
export { ForwardRef as ReactComponent };